/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
// @ts-ignore
// prettier-ignore
import type { RequestConfig,RequestFunctionRestArgs } from 'yapi-to-typescript';
import {
  Method,
  prepare,
  QueryStringArrayFormat,
  RequestBodyType,
  ResponseBodyType,
} from 'yapi-to-typescript';
// @ts-ignore
import request from '../ajax/index';

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>;

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult,
> = (TRequestConfig['requestDataOptional'] extends true
  ? (requestData?: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult
  : (
      requestData: TRequestData,
      ...args: RequestFunctionRestArgs<typeof request>
    ) => TRequestResult) & {
  requestConfig: TRequestConfig;
};

const mockUrl_0_6_0_0 = 'http://yapi.cai-inc.com/mock/3075' as any;
const devUrl_0_6_0_0 = '' as any;
const prodUrl_0_6_0_0 = '' as any;
const dataKey_0_6_0_0 = 'data' as any;

/**
 * 接口 [PC端单位公务卡管理列表↗](http://yapi.cai-inc.com/project/3075/interface/api/202726) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/pay/bankCard/pc/manager`
 * @更新时间 `2024-06-13 15:57:43`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardPcManagerPostRequest {
  /**
   * 操作员id
   */
  operatorId?: string;
  /**
   * 人员名称
   */
  userName?: string;
  /**
   * 公务卡卡号
   */
  accountNo?: string;
  /**
   * 处室ID
   */
  departmentID?: number;
  /**
   * 绑定状态
   */
  checkStatus?: number;
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
}

/**
 * 接口 [PC端单位公务卡管理列表↗](http://yapi.cai-inc.com/project/3075/interface/api/202726) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/pay/bankCard/pc/manager`
 * @更新时间 `2024-06-13 15:57:43`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardPcManagerPostResponse {
  success?: boolean;
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 操作员ID
       */
      operatorId?: number;
      /**
       * 姓名
       */
      userName?: string;
      /**
       * 所属单位
       */
      companyName?: string;
      /**
       * 所属处室
       */
      departmentName?: string[];
      /**
       * 确认状态 1:已确认，2:未确认
       */
      checkStatus?: number;
      /**
       * 银行卡号
       */
      accountNoList?: string[];
      /**
       * 账号编码
       * 「已废弃」
       */
      accountCode?: string;
      /**
       * 公务卡卡号
       * 「已废弃」
       */
      accountNo?: string;
    }[];
    /**
     * 第几页
     */
    pageNum?: number;
    /**
     * 每页记录数
     */
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 当前页的数量 <= pageSize，该属性来自ArrayList的size属性
     */
    size?: number;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [PC端单位公务卡管理列表↗](http://yapi.cai-inc.com/project/3075/interface/api/202726) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/pay/bankCard/pc/manager`
 * @更新时间 `2024-06-13 15:57:43`
 * @项目ID 3075
 */
type ZlbApiPayBankCardPcManagerPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bankCard/pc/manager',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [PC端单位公务卡管理列表↗](http://yapi.cai-inc.com/project/3075/interface/api/202726) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/pay/bankCard/pc/manager`
 * @更新时间 `2024-06-13 15:57:43`
 * @项目ID 3075
 */
const zlbApiPayBankCardPcManagerPostRequestConfig: ZlbApiPayBankCardPcManagerPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_0,
    devUrl: devUrl_0_6_0_0,
    prodUrl: prodUrl_0_6_0_0,
    path: '/zlb/api/pay/bankCard/pc/manager',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayBankCardPcManagerPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [PC端单位公务卡管理列表↗](http://yapi.cai-inc.com/project/3075/interface/api/202726) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/pay/bankCard/pc/manager`
 * @更新时间 `2024-06-13 15:57:43`
 * @项目ID 3075
 */
export const zlbApiPayBankCardPcManagerPost = /*#__PURE__*/ (
  requestData: ZlbApiPayBankCardPcManagerPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankCardPcManagerPostResponse>(
    prepare(zlbApiPayBankCardPcManagerPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankCardPcManagerPost.requestConfig = zlbApiPayBankCardPcManagerPostRequestConfig;

/**
 * 接口 [添加银行卡信息↗](http://yapi.cai-inc.com/project/3075/interface/api/202766) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/add`
 * @更新时间 `2024-06-13 15:57:43`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardAddPostRequest {
  /**
   * 银行代码
   */
  bankCode?: string;
  /**
   * 银行行号
   */
  bankNo?: string;
  /**
   * 开户银行
   */
  bankName?: string;
  /**
   * 开户城市
   */
  bankCity?: string;
  /**
   * 银行支行名称
   */
  bankBranchName?: string;
  /**
   * 银行区划编码
   */
  bankAreaCode?: string;
  /**
   * 银行卡号
   */
  accountNo?: string;
  /**
   * 账户名称
   */
  accountName?: string;
  /**
   * 绑定状态
   * 0-已确认，1-不确认，2-不需要，3-已跳过
   */
  confirmStatus?: number;
  /**
   * 账户状态
   */
  accountStatus?: number;
  /**
   * 账户类型，参见：{@link AccountTypeEnum}
   */
  accountType?: number;
  /**
   * 是否默认
   * 1:是，2:否
   */
  isDefault?: boolean;
  /**
   * logId
   */
  logId?: string;
  /**
   * 备注
   */
  remark?: string;
  /**
   * 省份编码
   */
  provinceCode?: string;
  /**
   * 省份名称
   */
  provinceName?: string;
  /**
   * 城市编码
   */
  cityCode?: string;
  /**
   * 城市名称
   */
  cityName?: string;
}

/**
 * 接口 [添加银行卡信息↗](http://yapi.cai-inc.com/project/3075/interface/api/202766) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/add`
 * @更新时间 `2024-06-13 15:57:43`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardAddPostResponse {
  success?: boolean;
  result?: {
    accountCode?: string;
    accountNo?: string;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [添加银行卡信息↗](http://yapi.cai-inc.com/project/3075/interface/api/202766) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/add`
 * @更新时间 `2024-06-13 15:57:43`
 * @项目ID 3075
 */
type ZlbApiPayBankCardAddPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bankCard/add',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [添加银行卡信息↗](http://yapi.cai-inc.com/project/3075/interface/api/202766) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/add`
 * @更新时间 `2024-06-13 15:57:43`
 * @项目ID 3075
 */
const zlbApiPayBankCardAddPostRequestConfig: ZlbApiPayBankCardAddPostRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_6_0_0,
  devUrl: devUrl_0_6_0_0,
  prodUrl: prodUrl_0_6_0_0,
  path: '/zlb/api/pay/bankCard/add',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_6_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'zlbApiPayBankCardAddPost',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 [添加银行卡信息↗](http://yapi.cai-inc.com/project/3075/interface/api/202766) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/add`
 * @更新时间 `2024-06-13 15:57:43`
 * @项目ID 3075
 */
export const zlbApiPayBankCardAddPost = /*#__PURE__*/ (
  requestData: ZlbApiPayBankCardAddPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankCardAddPostResponse>(
    prepare(zlbApiPayBankCardAddPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankCardAddPost.requestConfig = zlbApiPayBankCardAddPostRequestConfig;

/**
 * 接口 [根据操作人ID批量查询卡信息↗](http://yapi.cai-inc.com/project/3075/interface/api/234710) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/personal/batch`
 * @更新时间 `2024-06-13 15:57:42`
 * @项目ID 3075
 */
export type ZlbApiPayBankCardPersonalBatchPostRequest = number[];

/**
 * 接口 [根据操作人ID批量查询卡信息↗](http://yapi.cai-inc.com/project/3075/interface/api/234710) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/personal/batch`
 * @更新时间 `2024-06-13 15:57:42`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardPersonalBatchPostResponse {
  success?: boolean;
  result?: {
    /**
     * 账号编码
     */
    accountCode?: string;
    /**
     * 用户名称
     */
    userName?: string;
    /**
     * 用户ID
     */
    userId?: number;
    /**
     * 用户ID
     */
    operatorId?: number;
    /**
     * 财政区划代码
     */
    finaDivCode?: string;
    /**
     * 单位代码
     */
    companyCode?: string;
    /**
     * 单位名称
     */
    companyName?: string;
    /**
     * 银行代码
     */
    bankCode?: string;
    /**
     * 银行行号
     */
    bankNo?: string;
    /**
     * 银行名称
     */
    bankName?: string;
    /**
     * 支行名称
     */
    bankBranchName?: string;
    /**
     * 银行账户
     */
    accountNo?: string;
    /**
     * 账户名称
     */
    accountName?: string;
    /**
     * 账户状态
     * 0-未启用；1-启用
     */
    accountStatus?: number;
    /**
     * 账户类型
     * 1-公务卡；2-个人卡；3-工资卡
     */
    accountType?: number;
    /**
     * 账户类型名称
     * 1-公务卡；2-个人卡；3-工资卡
     */
    accountTypeName?: string;
    /**
     * 是否默认 0-否；1-是
     */
    isDefault?: number;
  }[];
  code?: string;
  message?: string;
}

/**
 * 接口 [根据操作人ID批量查询卡信息↗](http://yapi.cai-inc.com/project/3075/interface/api/234710) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/personal/batch`
 * @更新时间 `2024-06-13 15:57:42`
 * @项目ID 3075
 */
type ZlbApiPayBankCardPersonalBatchPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bankCard/personal/batch',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [根据操作人ID批量查询卡信息↗](http://yapi.cai-inc.com/project/3075/interface/api/234710) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/personal/batch`
 * @更新时间 `2024-06-13 15:57:42`
 * @项目ID 3075
 */
const zlbApiPayBankCardPersonalBatchPostRequestConfig: ZlbApiPayBankCardPersonalBatchPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_0,
    devUrl: devUrl_0_6_0_0,
    prodUrl: prodUrl_0_6_0_0,
    path: '/zlb/api/pay/bankCard/personal/batch',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayBankCardPersonalBatchPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据操作人ID批量查询卡信息↗](http://yapi.cai-inc.com/project/3075/interface/api/234710) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/personal/batch`
 * @更新时间 `2024-06-13 15:57:42`
 * @项目ID 3075
 */
export const zlbApiPayBankCardPersonalBatchPost = /*#__PURE__*/ (
  requestData: ZlbApiPayBankCardPersonalBatchPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankCardPersonalBatchPostResponse>(
    prepare(zlbApiPayBankCardPersonalBatchPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankCardPersonalBatchPost.requestConfig = zlbApiPayBankCardPersonalBatchPostRequestConfig;

/**
 * 接口 [查询个人名下所有银行卡信息和所有任职单位的公务卡↗](http://yapi.cai-inc.com/project/3075/interface/api/255994) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/personal`
 * @更新时间 `2024-06-13 15:57:42`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardPersonalPostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
}

/**
 * 接口 [查询个人名下所有银行卡信息和所有任职单位的公务卡↗](http://yapi.cai-inc.com/project/3075/interface/api/255994) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/personal`
 * @更新时间 `2024-06-13 15:57:42`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardPersonalPostResponse {
  success?: boolean;
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 主键
       */
      id?: number;
      /**
       * 平台账户唯一编号
       */
      accountCode?: string;
      /**
       * 公务卡三方账户id，唯一主键，用来分析和排查是否重复拉取问题
       */
      thirdAccountCode?: string;
      /**
       * 用户id
       */
      userId?: number;
      /**
       * 用户机构id
       */
      userOrgId?: number;
      /**
       * 用户名称
       */
      userName?: string;
      /**
       * 财政区划代码
       */
      finaDivCode?: string;
      /**
       * 单位代码
       */
      companyCode?: string;
      /**
       * 单位名称
       */
      companyName?: string;
      /**
       * 银行区域代码
       */
      bankAreaCode?: string;
      /**
       * 银行代码
       */
      bankCode?: string;
      /**
       * 银行行号
       */
      bankNo?: string;
      /**
       * 银行名称
       */
      bankName?: string;
      /**
       * 开户城市
       */
      bankCity?: string;
      /**
       * 银行支行名称
       */
      bankBranchName?: string;
      /**
       * 银行账户
       */
      accountNo?: string;
      /**
       * 不拖敏
       */
      accountNoWithoutDes?: string;
      /**
       * 账户名称
       */
      accountName?: string;
      /**
       * 账户状态：0-未启用；1-启用
       */
      accountStatus?: number;
      /**
       * 账户类型：1-公务卡；2-普通银行卡；3-单位工资卡；4-对公供应商银行卡；5-对私供销商银行卡 6-单位账户
       */
      accountType?: number;
      /**
       * 账户类型名称
       */
      accountTypeName?: string;
      /**
       * 账户类型：1-个人；2-单位
       */
      accountLevel?: number;
      /**
       * 账户类型名称
       */
      accountLevelName?: string;
      /**
       * 是否默认账户：0-否；1-是
       */
      isDefault?: number;
      /**
       * 支付状态 0：未支付 1:已支付
       */
      isPay?: number;
      /**
       * 备案状态，0：未备案 1：备案成功 2：备案失败，参照：{link FilingStatusEnum}
       */
      filingStatus?: number;
      /**
       * 备案过期时间
       */
      expireDate?: string;
      /**
       * 备注
       */
      remark?: string;
      /**
       * 用户ID
       */
      operatorId?: number;
      /**
       * 开户支行别名
       */
      bankBranchAliasName?: string;
      /**
       * 收款人身份证号
       */
      receiveIdNumber?: string;
    }[];
    /**
     * 第几页
     */
    pageNum?: number;
    /**
     * 每页记录数
     */
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 当前页的数量 <= pageSize，该属性来自ArrayList的size属性
     */
    size?: number;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [查询个人名下所有银行卡信息和所有任职单位的公务卡↗](http://yapi.cai-inc.com/project/3075/interface/api/255994) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/personal`
 * @更新时间 `2024-06-13 15:57:42`
 * @项目ID 3075
 */
type ZlbApiPayBankCardPersonalPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bankCard/personal',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询个人名下所有银行卡信息和所有任职单位的公务卡↗](http://yapi.cai-inc.com/project/3075/interface/api/255994) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/personal`
 * @更新时间 `2024-06-13 15:57:42`
 * @项目ID 3075
 */
const zlbApiPayBankCardPersonalPostRequestConfig: ZlbApiPayBankCardPersonalPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_0,
    devUrl: devUrl_0_6_0_0,
    prodUrl: prodUrl_0_6_0_0,
    path: '/zlb/api/pay/bankCard/personal',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayBankCardPersonalPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询个人名下所有银行卡信息和所有任职单位的公务卡↗](http://yapi.cai-inc.com/project/3075/interface/api/255994) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/personal`
 * @更新时间 `2024-06-13 15:57:42`
 * @项目ID 3075
 */
export const zlbApiPayBankCardPersonalPost = /*#__PURE__*/ (
  requestData: ZlbApiPayBankCardPersonalPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankCardPersonalPostResponse>(
    prepare(zlbApiPayBankCardPersonalPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankCardPersonalPost.requestConfig = zlbApiPayBankCardPersonalPostRequestConfig;

/**
 * 接口 [获取被他人绑定的公务卡↗](http://yapi.cai-inc.com/project/3075/interface/api/269706) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `GET /zlb/api/pay/bankCard/official/illegal`
 * @更新时间 `2024-06-13 15:57:42`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOfficialIllegalGetRequest {}

/**
 * 接口 [获取被他人绑定的公务卡↗](http://yapi.cai-inc.com/project/3075/interface/api/269706) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `GET /zlb/api/pay/bankCard/official/illegal`
 * @更新时间 `2024-06-13 15:57:42`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOfficialIllegalGetResponse {
  success?: boolean;
  result?: {
    id?: number;
    /**
     * 平台账户唯一编号
     */
    accountCode?: string;
    /**
     * 账户名
     */
    accountName?: string;
    /**
     * 大行行号
     */
    bankCode?: string;
    /**
     * 银行名称
     */
    bankName?: string;
    /**
     * 银行账户
     */
    accountNo?: string;
    /**
     * 浙里报机构名称
     */
    orgName?: string;
    /**
     * {@link cn.gov.zlb.finance.pay.api.enums.AccountTypeEnum}
     */
    accountType?: number;
    /**
     * {@link cn.gov.zlb.finance.pay.api.enums.AccountTypeEnum}
     * 账户类型：1-公务卡；2-普通银行卡；3-单位工资卡；4-对公供应商银行卡；5-对私供销商银行卡 6-单位账户
     */
    accountTypeName?: string;
    /**
     * 银行账户 用于公务卡中间4位脱敏展示
     */
    accountNoWithDes?: string;
  }[];
  code?: string;
  message?: string;
}

/**
 * 接口 [获取被他人绑定的公务卡↗](http://yapi.cai-inc.com/project/3075/interface/api/269706) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `GET /zlb/api/pay/bankCard/official/illegal`
 * @更新时间 `2024-06-13 15:57:42`
 * @项目ID 3075
 */
type ZlbApiPayBankCardOfficialIllegalGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bankCard/official/illegal',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取被他人绑定的公务卡↗](http://yapi.cai-inc.com/project/3075/interface/api/269706) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `GET /zlb/api/pay/bankCard/official/illegal`
 * @更新时间 `2024-06-13 15:57:42`
 * @项目ID 3075
 */
const zlbApiPayBankCardOfficialIllegalGetRequestConfig: ZlbApiPayBankCardOfficialIllegalGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_0,
    devUrl: devUrl_0_6_0_0,
    prodUrl: prodUrl_0_6_0_0,
    path: '/zlb/api/pay/bankCard/official/illegal',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayBankCardOfficialIllegalGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取被他人绑定的公务卡↗](http://yapi.cai-inc.com/project/3075/interface/api/269706) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `GET /zlb/api/pay/bankCard/official/illegal`
 * @更新时间 `2024-06-13 15:57:42`
 * @项目ID 3075
 */
export const zlbApiPayBankCardOfficialIllegalGet = /*#__PURE__*/ (
  requestData?: ZlbApiPayBankCardOfficialIllegalGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankCardOfficialIllegalGetResponse>(
    prepare(zlbApiPayBankCardOfficialIllegalGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankCardOfficialIllegalGet.requestConfig =
  zlbApiPayBankCardOfficialIllegalGetRequestConfig;

/**
 * 接口 [获取已绑定的公务卡↗](http://yapi.cai-inc.com/project/3075/interface/api/269714) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `GET /zlb/api/pay/bankCard/official/bound`
 * @更新时间 `2024-06-13 15:57:41`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOfficialBoundGetRequest {}

/**
 * 接口 [获取已绑定的公务卡↗](http://yapi.cai-inc.com/project/3075/interface/api/269714) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `GET /zlb/api/pay/bankCard/official/bound`
 * @更新时间 `2024-06-13 15:57:41`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOfficialBoundGetResponse {
  success?: boolean;
  result?: {
    /**
     * 主键
     */
    id?: number;
    /**
     * 平台账户唯一编号
     */
    accountCode?: string;
    /**
     * 公务卡三方账户id，唯一主键，用来分析和排查是否重复拉取问题
     */
    thirdAccountCode?: string;
    /**
     * 用户id
     */
    userId?: number;
    /**
     * 用户机构id
     */
    userOrgId?: number;
    /**
     * 用户名称
     */
    userName?: string;
    /**
     * 财政区划代码
     */
    finaDivCode?: string;
    /**
     * 单位代码
     */
    companyCode?: string;
    /**
     * 单位名称
     */
    companyName?: string;
    /**
     * 银行区域代码
     */
    bankAreaCode?: string;
    /**
     * 银行代码
     */
    bankCode?: string;
    /**
     * 银行行号
     */
    bankNo?: string;
    /**
     * 银行名称
     */
    bankName?: string;
    /**
     * 开户城市
     */
    bankCity?: string;
    /**
     * 银行支行名称
     */
    bankBranchName?: string;
    /**
     * 银行账户
     */
    accountNo?: string;
    /**
     * 不拖敏
     */
    accountNoWithoutDes?: string;
    /**
     * 账户名称
     */
    accountName?: string;
    /**
     * 账户状态：0-未启用；1-启用
     */
    accountStatus?: number;
    /**
     * 账户类型：1-公务卡；2-普通银行卡；3-单位工资卡；4-对公供应商银行卡；5-对私供销商银行卡 6-单位账户
     */
    accountType?: number;
    /**
     * 账户类型名称
     */
    accountTypeName?: string;
    /**
     * 账户类型：1-个人；2-单位
     */
    accountLevel?: number;
    /**
     * 账户类型名称
     */
    accountLevelName?: string;
    /**
     * 是否默认账户：0-否；1-是
     */
    isDefault?: number;
    /**
     * 支付状态 0：未支付 1:已支付
     */
    isPay?: number;
    /**
     * 备案状态，0：未备案 1：备案成功 2：备案失败，参照：{link FilingStatusEnum}
     */
    filingStatus?: number;
    /**
     * 备案过期时间
     */
    expireDate?: string;
    /**
     * 备注
     */
    remark?: string;
    /**
     * 用户ID
     */
    operatorId?: number;
    /**
     * 开户支行别名
     */
    bankBranchAliasName?: string;
    /**
     * 收款人身份证号
     */
    receiveIdNumber?: string;
  }[];
  code?: string;
  message?: string;
}

/**
 * 接口 [获取已绑定的公务卡↗](http://yapi.cai-inc.com/project/3075/interface/api/269714) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `GET /zlb/api/pay/bankCard/official/bound`
 * @更新时间 `2024-06-13 15:57:41`
 * @项目ID 3075
 */
type ZlbApiPayBankCardOfficialBoundGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bankCard/official/bound',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取已绑定的公务卡↗](http://yapi.cai-inc.com/project/3075/interface/api/269714) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `GET /zlb/api/pay/bankCard/official/bound`
 * @更新时间 `2024-06-13 15:57:41`
 * @项目ID 3075
 */
const zlbApiPayBankCardOfficialBoundGetRequestConfig: ZlbApiPayBankCardOfficialBoundGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_0,
    devUrl: devUrl_0_6_0_0,
    prodUrl: prodUrl_0_6_0_0,
    path: '/zlb/api/pay/bankCard/official/bound',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayBankCardOfficialBoundGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取已绑定的公务卡↗](http://yapi.cai-inc.com/project/3075/interface/api/269714) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `GET /zlb/api/pay/bankCard/official/bound`
 * @更新时间 `2024-06-13 15:57:41`
 * @项目ID 3075
 */
export const zlbApiPayBankCardOfficialBoundGet = /*#__PURE__*/ (
  requestData?: ZlbApiPayBankCardOfficialBoundGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankCardOfficialBoundGetResponse>(
    prepare(zlbApiPayBankCardOfficialBoundGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankCardOfficialBoundGet.requestConfig = zlbApiPayBankCardOfficialBoundGetRequestConfig;

/**
 * 接口 [获取可绑定的公务卡↗](http://yapi.cai-inc.com/project/3075/interface/api/270082) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `GET /zlb/api/pay/bankCard/official/bindable`
 * @更新时间 `2024-06-13 15:57:41`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOfficialBindableGetRequest {}

/**
 * 接口 [获取可绑定的公务卡↗](http://yapi.cai-inc.com/project/3075/interface/api/270082) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `GET /zlb/api/pay/bankCard/official/bindable`
 * @更新时间 `2024-06-13 15:57:41`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOfficialBindableGetResponse {
  success?: boolean;
  result?: {
    id?: number;
    /**
     * 平台账户唯一编号
     */
    accountCode?: string;
    /**
     * 账户名
     */
    accountName?: string;
    /**
     * 大行行号
     */
    bankCode?: string;
    /**
     * 银行名称
     */
    bankName?: string;
    /**
     * 银行账户
     */
    accountNo?: string;
    /**
     * 浙里报机构名称
     */
    orgName?: string;
    /**
     * {@link cn.gov.zlb.finance.pay.api.enums.AccountTypeEnum}
     */
    accountType?: number;
    /**
     * {@link cn.gov.zlb.finance.pay.api.enums.AccountTypeEnum}
     * 账户类型：1-公务卡；2-普通银行卡；3-单位工资卡；4-对公供应商银行卡；5-对私供销商银行卡 6-单位账户
     */
    accountTypeName?: string;
    /**
     * 银行账户 用于公务卡中间4位脱敏展示
     */
    accountNoWithDes?: string;
  }[];
  code?: string;
  message?: string;
}

/**
 * 接口 [获取可绑定的公务卡↗](http://yapi.cai-inc.com/project/3075/interface/api/270082) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `GET /zlb/api/pay/bankCard/official/bindable`
 * @更新时间 `2024-06-13 15:57:41`
 * @项目ID 3075
 */
type ZlbApiPayBankCardOfficialBindableGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bankCard/official/bindable',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取可绑定的公务卡↗](http://yapi.cai-inc.com/project/3075/interface/api/270082) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `GET /zlb/api/pay/bankCard/official/bindable`
 * @更新时间 `2024-06-13 15:57:41`
 * @项目ID 3075
 */
const zlbApiPayBankCardOfficialBindableGetRequestConfig: ZlbApiPayBankCardOfficialBindableGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_0,
    devUrl: devUrl_0_6_0_0,
    prodUrl: prodUrl_0_6_0_0,
    path: '/zlb/api/pay/bankCard/official/bindable',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayBankCardOfficialBindableGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取可绑定的公务卡↗](http://yapi.cai-inc.com/project/3075/interface/api/270082) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `GET /zlb/api/pay/bankCard/official/bindable`
 * @更新时间 `2024-06-13 15:57:41`
 * @项目ID 3075
 */
export const zlbApiPayBankCardOfficialBindableGet = /*#__PURE__*/ (
  requestData?: ZlbApiPayBankCardOfficialBindableGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankCardOfficialBindableGetResponse>(
    prepare(zlbApiPayBankCardOfficialBindableGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankCardOfficialBindableGet.requestConfig =
  zlbApiPayBankCardOfficialBindableGetRequestConfig;

/**
 * 接口 [解绑公务卡↗](http://yapi.cai-inc.com/project/3075/interface/api/272914) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/unbind`
 * @更新时间 `2024-06-13 15:57:43`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOfficialUnbindPostRequest {
  /**
   * 绑定的操作员ID
   */
  operatorId?: number;
  /**
   * 绑定的公务卡编码
   */
  accountCodeList?: string[];
}

/**
 * 接口 [解绑公务卡↗](http://yapi.cai-inc.com/project/3075/interface/api/272914) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/unbind`
 * @更新时间 `2024-06-13 15:57:43`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOfficialUnbindPostResponse {
  success?: boolean;
  result?: {};
  code?: string;
  message?: string;
}

/**
 * 接口 [解绑公务卡↗](http://yapi.cai-inc.com/project/3075/interface/api/272914) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/unbind`
 * @更新时间 `2024-06-13 15:57:43`
 * @项目ID 3075
 */
type ZlbApiPayBankCardOfficialUnbindPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bankCard/official/unbind',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [解绑公务卡↗](http://yapi.cai-inc.com/project/3075/interface/api/272914) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/unbind`
 * @更新时间 `2024-06-13 15:57:43`
 * @项目ID 3075
 */
const zlbApiPayBankCardOfficialUnbindPostRequestConfig: ZlbApiPayBankCardOfficialUnbindPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_0,
    devUrl: devUrl_0_6_0_0,
    prodUrl: prodUrl_0_6_0_0,
    path: '/zlb/api/pay/bankCard/official/unbind',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayBankCardOfficialUnbindPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [解绑公务卡↗](http://yapi.cai-inc.com/project/3075/interface/api/272914) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/unbind`
 * @更新时间 `2024-06-13 15:57:43`
 * @项目ID 3075
 */
export const zlbApiPayBankCardOfficialUnbindPost = /*#__PURE__*/ (
  requestData: ZlbApiPayBankCardOfficialUnbindPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankCardOfficialUnbindPostResponse>(
    prepare(zlbApiPayBankCardOfficialUnbindPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankCardOfficialUnbindPost.requestConfig =
  zlbApiPayBankCardOfficialUnbindPostRequestConfig;

/**
 * 接口 [同步机构单位下的公务卡↗](http://yapi.cai-inc.com/project/3075/interface/api/273202) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/sync`
 * @更新时间 `2024-06-13 15:57:40`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOfficialSyncPostRequest {
  orgId?: number;
}

/**
 * 接口 [同步机构单位下的公务卡↗](http://yapi.cai-inc.com/project/3075/interface/api/273202) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/sync`
 * @更新时间 `2024-06-13 15:57:40`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOfficialSyncPostResponse {
  success?: boolean;
  result?: {};
  code?: string;
  message?: string;
}

/**
 * 接口 [同步机构单位下的公务卡↗](http://yapi.cai-inc.com/project/3075/interface/api/273202) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/sync`
 * @更新时间 `2024-06-13 15:57:40`
 * @项目ID 3075
 */
type ZlbApiPayBankCardOfficialSyncPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bankCard/official/sync',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [同步机构单位下的公务卡↗](http://yapi.cai-inc.com/project/3075/interface/api/273202) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/sync`
 * @更新时间 `2024-06-13 15:57:40`
 * @项目ID 3075
 */
const zlbApiPayBankCardOfficialSyncPostRequestConfig: ZlbApiPayBankCardOfficialSyncPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_0,
    devUrl: devUrl_0_6_0_0,
    prodUrl: prodUrl_0_6_0_0,
    path: '/zlb/api/pay/bankCard/official/sync',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayBankCardOfficialSyncPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [同步机构单位下的公务卡↗](http://yapi.cai-inc.com/project/3075/interface/api/273202) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/sync`
 * @更新时间 `2024-06-13 15:57:40`
 * @项目ID 3075
 */
export const zlbApiPayBankCardOfficialSyncPost = /*#__PURE__*/ (
  requestData: ZlbApiPayBankCardOfficialSyncPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankCardOfficialSyncPostResponse>(
    prepare(zlbApiPayBankCardOfficialSyncPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankCardOfficialSyncPost.requestConfig = zlbApiPayBankCardOfficialSyncPostRequestConfig;

/**
 * 接口 [银行卡尾号校验↗](http://yapi.cai-inc.com/project/3075/interface/api/275322) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/tail-number-check`
 * @更新时间 `2024-06-13 15:57:42`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOfficialTailNumberCheckPostRequest {
  /**
   * 账号唯一编码
   */
  accountCode?: string;
  /**
   * 银行卡尾号
   */
  tailNumber?: string;
}

/**
 * 接口 [银行卡尾号校验↗](http://yapi.cai-inc.com/project/3075/interface/api/275322) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/tail-number-check`
 * @更新时间 `2024-06-13 15:57:42`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOfficialTailNumberCheckPostResponse {
  success?: boolean;
  result?: string;
  code?: string;
  message?: string;
}

/**
 * 接口 [银行卡尾号校验↗](http://yapi.cai-inc.com/project/3075/interface/api/275322) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/tail-number-check`
 * @更新时间 `2024-06-13 15:57:42`
 * @项目ID 3075
 */
type ZlbApiPayBankCardOfficialTailNumberCheckPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bankCard/official/tail-number-check',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [银行卡尾号校验↗](http://yapi.cai-inc.com/project/3075/interface/api/275322) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/tail-number-check`
 * @更新时间 `2024-06-13 15:57:42`
 * @项目ID 3075
 */
const zlbApiPayBankCardOfficialTailNumberCheckPostRequestConfig: ZlbApiPayBankCardOfficialTailNumberCheckPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_0,
    devUrl: devUrl_0_6_0_0,
    prodUrl: prodUrl_0_6_0_0,
    path: '/zlb/api/pay/bankCard/official/tail-number-check',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayBankCardOfficialTailNumberCheckPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [银行卡尾号校验↗](http://yapi.cai-inc.com/project/3075/interface/api/275322) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/tail-number-check`
 * @更新时间 `2024-06-13 15:57:42`
 * @项目ID 3075
 */
export const zlbApiPayBankCardOfficialTailNumberCheckPost = /*#__PURE__*/ (
  requestData: ZlbApiPayBankCardOfficialTailNumberCheckPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankCardOfficialTailNumberCheckPostResponse>(
    prepare(zlbApiPayBankCardOfficialTailNumberCheckPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankCardOfficialTailNumberCheckPost.requestConfig =
  zlbApiPayBankCardOfficialTailNumberCheckPostRequestConfig;

/**
 * 接口 [公务卡绑定↗](http://yapi.cai-inc.com/project/3075/interface/api/275330) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/bind`
 * @更新时间 `2024-06-13 15:57:43`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOfficialBindPostRequest {
  /**
   * 绑定的操作员ID
   */
  operatorId?: number;
  /**
   * 绑定的公务卡编码
   */
  accountCodeList?: string[];
}

/**
 * 接口 [公务卡绑定↗](http://yapi.cai-inc.com/project/3075/interface/api/275330) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/bind`
 * @更新时间 `2024-06-13 15:57:43`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOfficialBindPostResponse {
  success?: boolean;
  result?: {};
  code?: string;
  message?: string;
}

/**
 * 接口 [公务卡绑定↗](http://yapi.cai-inc.com/project/3075/interface/api/275330) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/bind`
 * @更新时间 `2024-06-13 15:57:43`
 * @项目ID 3075
 */
type ZlbApiPayBankCardOfficialBindPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bankCard/official/bind',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [公务卡绑定↗](http://yapi.cai-inc.com/project/3075/interface/api/275330) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/bind`
 * @更新时间 `2024-06-13 15:57:43`
 * @项目ID 3075
 */
const zlbApiPayBankCardOfficialBindPostRequestConfig: ZlbApiPayBankCardOfficialBindPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_0,
    devUrl: devUrl_0_6_0_0,
    prodUrl: prodUrl_0_6_0_0,
    path: '/zlb/api/pay/bankCard/official/bind',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayBankCardOfficialBindPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [公务卡绑定↗](http://yapi.cai-inc.com/project/3075/interface/api/275330) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/bind`
 * @更新时间 `2024-06-13 15:57:43`
 * @项目ID 3075
 */
export const zlbApiPayBankCardOfficialBindPost = /*#__PURE__*/ (
  requestData: ZlbApiPayBankCardOfficialBindPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankCardOfficialBindPostResponse>(
    prepare(zlbApiPayBankCardOfficialBindPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankCardOfficialBindPost.requestConfig = zlbApiPayBankCardOfficialBindPostRequestConfig;

/**
 * 接口 [返回是否需要添加银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/275338) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `GET /zlb/api/pay/bankCard/need-add-account`
 * @更新时间 `2024-06-13 15:57:40`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardNeedAddAccountGetRequest {}

/**
 * 接口 [返回是否需要添加银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/275338) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `GET /zlb/api/pay/bankCard/need-add-account`
 * @更新时间 `2024-06-13 15:57:40`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardNeedAddAccountGetResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [返回是否需要添加银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/275338) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `GET /zlb/api/pay/bankCard/need-add-account`
 * @更新时间 `2024-06-13 15:57:40`
 * @项目ID 3075
 */
type ZlbApiPayBankCardNeedAddAccountGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bankCard/need-add-account',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [返回是否需要添加银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/275338) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `GET /zlb/api/pay/bankCard/need-add-account`
 * @更新时间 `2024-06-13 15:57:40`
 * @项目ID 3075
 */
const zlbApiPayBankCardNeedAddAccountGetRequestConfig: ZlbApiPayBankCardNeedAddAccountGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_0,
    devUrl: devUrl_0_6_0_0,
    prodUrl: prodUrl_0_6_0_0,
    path: '/zlb/api/pay/bankCard/need-add-account',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayBankCardNeedAddAccountGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [返回是否需要添加银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/275338) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `GET /zlb/api/pay/bankCard/need-add-account`
 * @更新时间 `2024-06-13 15:57:40`
 * @项目ID 3075
 */
export const zlbApiPayBankCardNeedAddAccountGet = /*#__PURE__*/ (
  requestData?: ZlbApiPayBankCardNeedAddAccountGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankCardNeedAddAccountGetResponse>(
    prepare(zlbApiPayBankCardNeedAddAccountGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankCardNeedAddAccountGet.requestConfig = zlbApiPayBankCardNeedAddAccountGetRequestConfig;

/**
 * 接口 [获取操作员可绑定的公务卡-财务管理场景↗](http://yapi.cai-inc.com/project/3075/interface/api/285954) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/pay/bankCard/official/bindable-accountant`
 * @更新时间 `2024-06-13 15:57:41`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOfficialBindableAccountantGetRequest {
  /**
   * 操作员ID
   */
  operatorId: string;
}

/**
 * 接口 [获取操作员可绑定的公务卡-财务管理场景↗](http://yapi.cai-inc.com/project/3075/interface/api/285954) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/pay/bankCard/official/bindable-accountant`
 * @更新时间 `2024-06-13 15:57:41`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOfficialBindableAccountantGetResponse {
  success?: boolean;
  result?: {
    id?: number;
    /**
     * 平台账户唯一编号
     */
    accountCode?: string;
    /**
     * 账户名
     */
    accountName?: string;
    /**
     * 大行行号
     */
    bankCode?: string;
    /**
     * 银行名称
     */
    bankName?: string;
    /**
     * 银行账户
     */
    accountNo?: string;
    /**
     * 浙里报机构名称
     */
    orgName?: string;
    /**
     * {@link cn.gov.zlb.finance.pay.api.enums.AccountTypeEnum}
     */
    accountType?: number;
    /**
     * {@link cn.gov.zlb.finance.pay.api.enums.AccountTypeEnum}
     * 账户类型：1-公务卡；2-普通银行卡；3-单位工资卡；4-对公供应商银行卡；5-对私供销商银行卡 6-单位账户
     */
    accountTypeName?: string;
    /**
     * 银行账户 用于公务卡中间4位脱敏展示
     */
    accountNoWithDes?: string;
  }[];
  code?: string;
  message?: string;
}

/**
 * 接口 [获取操作员可绑定的公务卡-财务管理场景↗](http://yapi.cai-inc.com/project/3075/interface/api/285954) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/pay/bankCard/official/bindable-accountant`
 * @更新时间 `2024-06-13 15:57:41`
 * @项目ID 3075
 */
type ZlbApiPayBankCardOfficialBindableAccountantGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bankCard/official/bindable-accountant',
    'data',
    string,
    'operatorId',
    false
  >
>;

/**
 * 接口 [获取操作员可绑定的公务卡-财务管理场景↗](http://yapi.cai-inc.com/project/3075/interface/api/285954) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/pay/bankCard/official/bindable-accountant`
 * @更新时间 `2024-06-13 15:57:41`
 * @项目ID 3075
 */
const zlbApiPayBankCardOfficialBindableAccountantGetRequestConfig: ZlbApiPayBankCardOfficialBindableAccountantGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_0,
    devUrl: devUrl_0_6_0_0,
    prodUrl: prodUrl_0_6_0_0,
    path: '/zlb/api/pay/bankCard/official/bindable-accountant',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_0,
    paramNames: [],
    queryNames: ['operatorId'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayBankCardOfficialBindableAccountantGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取操作员可绑定的公务卡-财务管理场景↗](http://yapi.cai-inc.com/project/3075/interface/api/285954) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/pay/bankCard/official/bindable-accountant`
 * @更新时间 `2024-06-13 15:57:41`
 * @项目ID 3075
 */
export const zlbApiPayBankCardOfficialBindableAccountantGet = /*#__PURE__*/ (
  requestData: ZlbApiPayBankCardOfficialBindableAccountantGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankCardOfficialBindableAccountantGetResponse>(
    prepare(zlbApiPayBankCardOfficialBindableAccountantGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankCardOfficialBindableAccountantGet.requestConfig =
  zlbApiPayBankCardOfficialBindableAccountantGetRequestConfig;

/**
 * 接口 [获取被已绑定的公务卡-财务管理场景↗](http://yapi.cai-inc.com/project/3075/interface/api/285962) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/pay/bankCard/official/bound-accountant`
 * @更新时间 `2024-06-13 15:57:41`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOfficialBoundAccountantGetRequest {
  operatorId: string;
}

/**
 * 接口 [获取被已绑定的公务卡-财务管理场景↗](http://yapi.cai-inc.com/project/3075/interface/api/285962) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/pay/bankCard/official/bound-accountant`
 * @更新时间 `2024-06-13 15:57:41`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOfficialBoundAccountantGetResponse {
  success?: boolean;
  result?: {
    /**
     * 主键
     */
    id?: number;
    /**
     * 平台账户唯一编号
     */
    accountCode?: string;
    /**
     * 公务卡三方账户id，唯一主键，用来分析和排查是否重复拉取问题
     */
    thirdAccountCode?: string;
    /**
     * 用户id
     */
    userId?: number;
    /**
     * 用户机构id
     */
    userOrgId?: number;
    /**
     * 用户名称
     */
    userName?: string;
    /**
     * 财政区划代码
     */
    finaDivCode?: string;
    /**
     * 单位代码
     */
    companyCode?: string;
    /**
     * 单位名称
     */
    companyName?: string;
    /**
     * 银行区域代码
     */
    bankAreaCode?: string;
    /**
     * 银行代码
     */
    bankCode?: string;
    /**
     * 银行行号
     */
    bankNo?: string;
    /**
     * 银行名称
     */
    bankName?: string;
    /**
     * 开户城市
     */
    bankCity?: string;
    /**
     * 银行支行名称
     */
    bankBranchName?: string;
    /**
     * 银行账户
     */
    accountNo?: string;
    /**
     * 不拖敏
     */
    accountNoWithoutDes?: string;
    /**
     * 账户名称
     */
    accountName?: string;
    /**
     * 账户状态：0-未启用；1-启用
     */
    accountStatus?: number;
    /**
     * 账户类型：1-公务卡；2-普通银行卡；3-单位工资卡；4-对公供应商银行卡；5-对私供销商银行卡 6-单位账户
     */
    accountType?: number;
    /**
     * 账户类型名称
     */
    accountTypeName?: string;
    /**
     * 账户类型：1-个人；2-单位
     */
    accountLevel?: number;
    /**
     * 账户类型名称
     */
    accountLevelName?: string;
    /**
     * 是否默认账户：0-否；1-是
     */
    isDefault?: number;
    /**
     * 支付状态 0：未支付 1:已支付
     */
    isPay?: number;
    /**
     * 备案状态，0：未备案 1：备案成功 2：备案失败，参照：{link FilingStatusEnum}
     */
    filingStatus?: number;
    /**
     * 备案过期时间
     */
    expireDate?: string;
    /**
     * 备注
     */
    remark?: string;
    /**
     * 用户ID
     */
    operatorId?: number;
    /**
     * 开户支行别名
     */
    bankBranchAliasName?: string;
    /**
     * 收款人身份证号
     */
    receiveIdNumber?: string;
  }[];
  code?: string;
  message?: string;
}

/**
 * 接口 [获取被已绑定的公务卡-财务管理场景↗](http://yapi.cai-inc.com/project/3075/interface/api/285962) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/pay/bankCard/official/bound-accountant`
 * @更新时间 `2024-06-13 15:57:41`
 * @项目ID 3075
 */
type ZlbApiPayBankCardOfficialBoundAccountantGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bankCard/official/bound-accountant',
    'data',
    string,
    'operatorId',
    false
  >
>;

/**
 * 接口 [获取被已绑定的公务卡-财务管理场景↗](http://yapi.cai-inc.com/project/3075/interface/api/285962) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/pay/bankCard/official/bound-accountant`
 * @更新时间 `2024-06-13 15:57:41`
 * @项目ID 3075
 */
const zlbApiPayBankCardOfficialBoundAccountantGetRequestConfig: ZlbApiPayBankCardOfficialBoundAccountantGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_0,
    devUrl: devUrl_0_6_0_0,
    prodUrl: prodUrl_0_6_0_0,
    path: '/zlb/api/pay/bankCard/official/bound-accountant',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_0,
    paramNames: [],
    queryNames: ['operatorId'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayBankCardOfficialBoundAccountantGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取被已绑定的公务卡-财务管理场景↗](http://yapi.cai-inc.com/project/3075/interface/api/285962) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/pay/bankCard/official/bound-accountant`
 * @更新时间 `2024-06-13 15:57:41`
 * @项目ID 3075
 */
export const zlbApiPayBankCardOfficialBoundAccountantGet = /*#__PURE__*/ (
  requestData: ZlbApiPayBankCardOfficialBoundAccountantGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankCardOfficialBoundAccountantGetResponse>(
    prepare(zlbApiPayBankCardOfficialBoundAccountantGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankCardOfficialBoundAccountantGet.requestConfig =
  zlbApiPayBankCardOfficialBoundAccountantGetRequestConfig;

/**
 * 接口 [获取操作员被他人绑定的公务卡-财务管理场景↗](http://yapi.cai-inc.com/project/3075/interface/api/285970) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/pay/bankCard/official/illegal-accountant`
 * @更新时间 `2024-06-13 15:57:42`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOfficialIllegalAccountantGetRequest {
  operatorId: string;
}

/**
 * 接口 [获取操作员被他人绑定的公务卡-财务管理场景↗](http://yapi.cai-inc.com/project/3075/interface/api/285970) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/pay/bankCard/official/illegal-accountant`
 * @更新时间 `2024-06-13 15:57:42`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOfficialIllegalAccountantGetResponse {
  success?: boolean;
  result?: {
    id?: number;
    /**
     * 平台账户唯一编号
     */
    accountCode?: string;
    /**
     * 账户名
     */
    accountName?: string;
    /**
     * 大行行号
     */
    bankCode?: string;
    /**
     * 银行名称
     */
    bankName?: string;
    /**
     * 银行账户
     */
    accountNo?: string;
    /**
     * 浙里报机构名称
     */
    orgName?: string;
    /**
     * {@link cn.gov.zlb.finance.pay.api.enums.AccountTypeEnum}
     */
    accountType?: number;
    /**
     * {@link cn.gov.zlb.finance.pay.api.enums.AccountTypeEnum}
     * 账户类型：1-公务卡；2-普通银行卡；3-单位工资卡；4-对公供应商银行卡；5-对私供销商银行卡 6-单位账户
     */
    accountTypeName?: string;
    /**
     * 银行账户 用于公务卡中间4位脱敏展示
     */
    accountNoWithDes?: string;
  }[];
  code?: string;
  message?: string;
}

/**
 * 接口 [获取操作员被他人绑定的公务卡-财务管理场景↗](http://yapi.cai-inc.com/project/3075/interface/api/285970) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/pay/bankCard/official/illegal-accountant`
 * @更新时间 `2024-06-13 15:57:42`
 * @项目ID 3075
 */
type ZlbApiPayBankCardOfficialIllegalAccountantGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bankCard/official/illegal-accountant',
    'data',
    string,
    'operatorId',
    false
  >
>;

/**
 * 接口 [获取操作员被他人绑定的公务卡-财务管理场景↗](http://yapi.cai-inc.com/project/3075/interface/api/285970) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/pay/bankCard/official/illegal-accountant`
 * @更新时间 `2024-06-13 15:57:42`
 * @项目ID 3075
 */
const zlbApiPayBankCardOfficialIllegalAccountantGetRequestConfig: ZlbApiPayBankCardOfficialIllegalAccountantGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_0,
    devUrl: devUrl_0_6_0_0,
    prodUrl: prodUrl_0_6_0_0,
    path: '/zlb/api/pay/bankCard/official/illegal-accountant',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_0,
    paramNames: [],
    queryNames: ['operatorId'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayBankCardOfficialIllegalAccountantGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取操作员被他人绑定的公务卡-财务管理场景↗](http://yapi.cai-inc.com/project/3075/interface/api/285970) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/pay/bankCard/official/illegal-accountant`
 * @更新时间 `2024-06-13 15:57:42`
 * @项目ID 3075
 */
export const zlbApiPayBankCardOfficialIllegalAccountantGet = /*#__PURE__*/ (
  requestData: ZlbApiPayBankCardOfficialIllegalAccountantGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankCardOfficialIllegalAccountantGetResponse>(
    prepare(zlbApiPayBankCardOfficialIllegalAccountantGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankCardOfficialIllegalAccountantGet.requestConfig =
  zlbApiPayBankCardOfficialIllegalAccountantGetRequestConfig;

/**
 * 接口 [公务卡管理列表↗](http://yapi.cai-inc.com/project/3075/interface/api/320450) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/list`
 * @更新时间 `2024-06-13 15:57:44`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOfficialListPostRequest {
  /**
   * 前端：持卡人姓名 后端：账户名称
   */
  accountName?: string;
  /**
   * 银行账号
   */
  accountNo?: string;
  /**
   * 绑定状态：0-未绑定；1-已绑定
   */
  bindStatus?: number;
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
}

/**
 * 接口 [公务卡管理列表↗](http://yapi.cai-inc.com/project/3075/interface/api/320450) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/list`
 * @更新时间 `2024-06-13 15:57:44`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOfficialListPostResponse {
  success?: boolean;
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 银行账户唯一编号
       */
      accountCode?: string;
      /**
       * 前端：持卡人姓名 后端：账户名称
       */
      accountName?: string;
      /**
       * 银行账号
       */
      accountNo?: string;
      /**
       * 开户银行
       */
      bankName?: string;
      /**
       * 绑定状态：0-未绑定；1-已绑定
       */
      bindStatus?: number;
      /**
       * 绑定状态(前端展示)：0-未绑定；1-已绑定
       */
      bindStatusName?: string;
      /**
       * 前端：绑定人员id 后端：操作员id
       */
      operatorId?: number;
      /**
       * 前端：绑定人员名称 后端：用户名称
       */
      userName?: string;
      /**
       * 绑定人员部门
       */
      departmentNames?: string[];
    }[];
    /**
     * 第几页
     */
    pageNum?: number;
    /**
     * 每页记录数
     */
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 当前页的数量 <= pageSize，该属性来自ArrayList的size属性
     */
    size?: number;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [公务卡管理列表↗](http://yapi.cai-inc.com/project/3075/interface/api/320450) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/list`
 * @更新时间 `2024-06-13 15:57:44`
 * @项目ID 3075
 */
type ZlbApiPayBankCardOfficialListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bankCard/official/list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [公务卡管理列表↗](http://yapi.cai-inc.com/project/3075/interface/api/320450) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/list`
 * @更新时间 `2024-06-13 15:57:44`
 * @项目ID 3075
 */
const zlbApiPayBankCardOfficialListPostRequestConfig: ZlbApiPayBankCardOfficialListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_0,
    devUrl: devUrl_0_6_0_0,
    prodUrl: prodUrl_0_6_0_0,
    path: '/zlb/api/pay/bankCard/official/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayBankCardOfficialListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [公务卡管理列表↗](http://yapi.cai-inc.com/project/3075/interface/api/320450) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/list`
 * @更新时间 `2024-06-13 15:57:44`
 * @项目ID 3075
 */
export const zlbApiPayBankCardOfficialListPost = /*#__PURE__*/ (
  requestData: ZlbApiPayBankCardOfficialListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankCardOfficialListPostResponse>(
    prepare(zlbApiPayBankCardOfficialListPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankCardOfficialListPost.requestConfig = zlbApiPayBankCardOfficialListPostRequestConfig;

/**
 * 接口 [编辑公务卡↗](http://yapi.cai-inc.com/project/3075/interface/api/320458) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/edit`
 * @更新时间 `2022-10-25 11:31:11`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOfficialEditPostRequest {
  /**
   * 前端：持卡人姓名 后端：账户名称
   */
  accountName: string;
  /**
   * 银行账号
   */
  accountNo: string;
  /**
   * 银行行号
   */
  bankNo: string;
  /**
   * 银行代码
   */
  bankCode: string;
  /**
   * 开户银行
   */
  bankName: string;
  /**
   * 绑定状态：0-未绑定；1-已绑定
   */
  bindStatus?: number;
  /**
   * 前端：绑定人员id 后端：操作员id
   */
  operatorId?: number;
  /**
   * 前端：绑定人员名称 后端：用户名称
   */
  userName?: string;
}

/**
 * 接口 [编辑公务卡↗](http://yapi.cai-inc.com/project/3075/interface/api/320458) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/edit`
 * @更新时间 `2022-10-25 11:31:11`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOfficialEditPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {};
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [编辑公务卡↗](http://yapi.cai-inc.com/project/3075/interface/api/320458) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/edit`
 * @更新时间 `2022-10-25 11:31:11`
 * @项目ID 3075
 */
type ZlbApiPayBankCardOfficialEditPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bankCard/official/edit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [编辑公务卡↗](http://yapi.cai-inc.com/project/3075/interface/api/320458) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/edit`
 * @更新时间 `2022-10-25 11:31:11`
 * @项目ID 3075
 */
const zlbApiPayBankCardOfficialEditPostRequestConfig: ZlbApiPayBankCardOfficialEditPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_0,
    devUrl: devUrl_0_6_0_0,
    prodUrl: prodUrl_0_6_0_0,
    path: '/zlb/api/pay/bankCard/official/edit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayBankCardOfficialEditPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [编辑公务卡↗](http://yapi.cai-inc.com/project/3075/interface/api/320458) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/edit`
 * @更新时间 `2022-10-25 11:31:11`
 * @项目ID 3075
 */
export const zlbApiPayBankCardOfficialEditPost = /*#__PURE__*/ (
  requestData: ZlbApiPayBankCardOfficialEditPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankCardOfficialEditPostResponse>(
    prepare(zlbApiPayBankCardOfficialEditPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankCardOfficialEditPost.requestConfig = zlbApiPayBankCardOfficialEditPostRequestConfig;

/**
 * 接口 [查看公务卡详情↗](http://yapi.cai-inc.com/project/3075/interface/api/320474) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `GET /zlb/api/pay/bankCard/official/detail/{accountCode}`
 * @更新时间 `2022-10-25 11:31:11`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOfficialDetailAccountCodeGetRequest {
  /**
   * 银行账户唯一编号
   */
  accountCode: string;
}

/**
 * 接口 [查看公务卡详情↗](http://yapi.cai-inc.com/project/3075/interface/api/320474) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `GET /zlb/api/pay/bankCard/official/detail/{accountCode}`
 * @更新时间 `2022-10-25 11:31:11`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOfficialDetailAccountCodeGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 银行账户唯一编号
       */
      accountCode?: string;
      /**
       * 前端：持卡人姓名 后端：账户名称
       */
      accountName?: string;
      /**
       * 银行账号
       */
      accountNo?: string;
      /**
       * 开户银行
       */
      bankName?: string;
      /**
       * 绑定状态：0-未绑定；1-已绑定
       */
      bindStatus?: number;
      /**
       * 前端：绑定人员id 后端：操作员id
       */
      operatorId?: number;
      /**
       * 前端：绑定人员名称 后端：用户名称
       */
      userName?: string;
    }[];
    /**
     * 第几页
     */
    pageNum?: number;
    /**
     * 每页记录数
     */
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 当前页的数量 <= pageSize，该属性来自ArrayList的size属性
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查看公务卡详情↗](http://yapi.cai-inc.com/project/3075/interface/api/320474) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `GET /zlb/api/pay/bankCard/official/detail/{accountCode}`
 * @更新时间 `2022-10-25 11:31:11`
 * @项目ID 3075
 */
type ZlbApiPayBankCardOfficialDetailAccountCodeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bankCard/official/detail/{accountCode}',
    'data',
    'accountCode',
    string,
    false
  >
>;

/**
 * 接口 [查看公务卡详情↗](http://yapi.cai-inc.com/project/3075/interface/api/320474) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `GET /zlb/api/pay/bankCard/official/detail/{accountCode}`
 * @更新时间 `2022-10-25 11:31:11`
 * @项目ID 3075
 */
const zlbApiPayBankCardOfficialDetailAccountCodeGetRequestConfig: ZlbApiPayBankCardOfficialDetailAccountCodeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_0,
    devUrl: devUrl_0_6_0_0,
    prodUrl: prodUrl_0_6_0_0,
    path: '/zlb/api/pay/bankCard/official/detail/{accountCode}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_0,
    paramNames: ['accountCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayBankCardOfficialDetailAccountCodeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查看公务卡详情↗](http://yapi.cai-inc.com/project/3075/interface/api/320474) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `GET /zlb/api/pay/bankCard/official/detail/{accountCode}`
 * @更新时间 `2022-10-25 11:31:11`
 * @项目ID 3075
 */
export const zlbApiPayBankCardOfficialDetailAccountCodeGet = /*#__PURE__*/ (
  requestData: ZlbApiPayBankCardOfficialDetailAccountCodeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankCardOfficialDetailAccountCodeGetResponse>(
    prepare(zlbApiPayBankCardOfficialDetailAccountCodeGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankCardOfficialDetailAccountCodeGet.requestConfig =
  zlbApiPayBankCardOfficialDetailAccountCodeGetRequestConfig;

/**
 * 接口 [新增公务卡↗](http://yapi.cai-inc.com/project/3075/interface/api/320618) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/add`
 * @更新时间 `2024-06-13 15:57:44`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOfficialAddPostRequest {
  /**
   * 前端：持卡人姓名 后端：账户名称
   */
  accountName: string;
  /**
   * 银行账号
   */
  accountNo: string;
  /**
   * 银行行号
   */
  bankNo: string;
  /**
   * 银行代码
   */
  bankCode: string;
  /**
   * 开户银行
   */
  bankName: string;
}

/**
 * 接口 [新增公务卡↗](http://yapi.cai-inc.com/project/3075/interface/api/320618) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/add`
 * @更新时间 `2024-06-13 15:57:44`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOfficialAddPostResponse {
  success?: boolean;
  result?: {
    accountCode?: string;
    accountNo?: string;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [新增公务卡↗](http://yapi.cai-inc.com/project/3075/interface/api/320618) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/add`
 * @更新时间 `2024-06-13 15:57:44`
 * @项目ID 3075
 */
type ZlbApiPayBankCardOfficialAddPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bankCard/official/add',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [新增公务卡↗](http://yapi.cai-inc.com/project/3075/interface/api/320618) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/add`
 * @更新时间 `2024-06-13 15:57:44`
 * @项目ID 3075
 */
const zlbApiPayBankCardOfficialAddPostRequestConfig: ZlbApiPayBankCardOfficialAddPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_0,
    devUrl: devUrl_0_6_0_0,
    prodUrl: prodUrl_0_6_0_0,
    path: '/zlb/api/pay/bankCard/official/add',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayBankCardOfficialAddPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [新增公务卡↗](http://yapi.cai-inc.com/project/3075/interface/api/320618) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/add`
 * @更新时间 `2024-06-13 15:57:44`
 * @项目ID 3075
 */
export const zlbApiPayBankCardOfficialAddPost = /*#__PURE__*/ (
  requestData: ZlbApiPayBankCardOfficialAddPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankCardOfficialAddPostResponse>(
    prepare(zlbApiPayBankCardOfficialAddPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankCardOfficialAddPost.requestConfig = zlbApiPayBankCardOfficialAddPostRequestConfig;

/**
 * 接口 [根据持卡人姓名精确查询单位内人员列表↗](http://yapi.cai-inc.com/project/3075/interface/api/322098) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/search-operator/{accountName}`
 * @更新时间 `2024-06-13 15:57:44`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOfficialSearchOperatorAccountNamePostRequest {
  /**
   * 持卡人姓名（账户名称）
   */
  accountName: string;
}

/**
 * 接口 [根据持卡人姓名精确查询单位内人员列表↗](http://yapi.cai-inc.com/project/3075/interface/api/322098) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/search-operator/{accountName}`
 * @更新时间 `2024-06-13 15:57:44`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOfficialSearchOperatorAccountNamePostResponse {
  success?: boolean;
  result?: {
    /**
     * 绑定人员id
     */
    operatorId?: number;
    /**
     * 姓名
     */
    displayName?: string;
    /**
     * 部门名称
     */
    departmentNames?: string[];
  }[];
  code?: string;
  message?: string;
}

/**
 * 接口 [根据持卡人姓名精确查询单位内人员列表↗](http://yapi.cai-inc.com/project/3075/interface/api/322098) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/search-operator/{accountName}`
 * @更新时间 `2024-06-13 15:57:44`
 * @项目ID 3075
 */
type ZlbApiPayBankCardOfficialSearchOperatorAccountNamePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bankCard/official/search-operator/{accountName}',
    'data',
    'accountName',
    string,
    false
  >
>;

/**
 * 接口 [根据持卡人姓名精确查询单位内人员列表↗](http://yapi.cai-inc.com/project/3075/interface/api/322098) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/search-operator/{accountName}`
 * @更新时间 `2024-06-13 15:57:44`
 * @项目ID 3075
 */
const zlbApiPayBankCardOfficialSearchOperatorAccountNamePostRequestConfig: ZlbApiPayBankCardOfficialSearchOperatorAccountNamePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_0,
    devUrl: devUrl_0_6_0_0,
    prodUrl: prodUrl_0_6_0_0,
    path: '/zlb/api/pay/bankCard/official/search-operator/{accountName}',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.none,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_0,
    paramNames: ['accountName'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayBankCardOfficialSearchOperatorAccountNamePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据持卡人姓名精确查询单位内人员列表↗](http://yapi.cai-inc.com/project/3075/interface/api/322098) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/search-operator/{accountName}`
 * @更新时间 `2024-06-13 15:57:44`
 * @项目ID 3075
 */
export const zlbApiPayBankCardOfficialSearchOperatorAccountNamePost = /*#__PURE__*/ (
  requestData: ZlbApiPayBankCardOfficialSearchOperatorAccountNamePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankCardOfficialSearchOperatorAccountNamePostResponse>(
    prepare(zlbApiPayBankCardOfficialSearchOperatorAccountNamePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankCardOfficialSearchOperatorAccountNamePost.requestConfig =
  zlbApiPayBankCardOfficialSearchOperatorAccountNamePostRequestConfig;

/**
 * 接口 [宁波公务卡消费记录查询↗](http://yapi.cai-inc.com/project/3075/interface/api/455146) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/nb/consumer-record`
 * @更新时间 `2024-06-13 15:57:45`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOfficialNbConsumerRecordPostRequest {
  /**
   * 持卡人
   */
  accountName?: string;
  /**
   * 账户唯一编码
   */
  accountCode?: string;
  /**
   * 消费日期
   */
  consumptionDate?: string;
  /**
   * 消费金额
   */
  amount?: number;
  nbOffCardConsRecQryList?: {
    /**
     * 账户唯一编码
     */
    accountCode: string;
    /**
     * 消费日期
     */
    consumptionDate: string;
    /**
     * 消费金额
     */
    amount: number;
  }[];
  pageSize?: number;
  pageNo?: number;
  sortField?: string;
  sortBy?: string;
}

/**
 * 接口 [宁波公务卡消费记录查询↗](http://yapi.cai-inc.com/project/3075/interface/api/455146) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/nb/consumer-record`
 * @更新时间 `2024-06-13 15:57:45`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOfficialNbConsumerRecordPostResponse {
  success?: boolean;
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 消费日期
       */
      consumptionDate?: string;
      /**
       * 交易流水号
       */
      tradeFlowNo?: string;
      /**
       * 持卡人
       */
      accountName?: string;
      /**
       * 卡号
       */
      accountNo?: string;
      /**
       * 消费金额
       */
      amount?: number;
      /**
       * 消费内容
       */
      context?: string;
      /**
       * 消费商家
       */
      merchantName?: string;
      /**
       * 状态 1-正常 2-重复 3-无记录
       */
      status?: number;
    }[];
    /**
     * 第几页
     */
    pageNum?: number;
    /**
     * 每页记录数
     */
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 当前页的数量 <= pageSize，该属性来自ArrayList的size属性
     */
    size?: number;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [宁波公务卡消费记录查询↗](http://yapi.cai-inc.com/project/3075/interface/api/455146) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/nb/consumer-record`
 * @更新时间 `2024-06-13 15:57:45`
 * @项目ID 3075
 */
type ZlbApiPayBankCardOfficialNbConsumerRecordPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bankCard/official/nb/consumer-record',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [宁波公务卡消费记录查询↗](http://yapi.cai-inc.com/project/3075/interface/api/455146) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/nb/consumer-record`
 * @更新时间 `2024-06-13 15:57:45`
 * @项目ID 3075
 */
const zlbApiPayBankCardOfficialNbConsumerRecordPostRequestConfig: ZlbApiPayBankCardOfficialNbConsumerRecordPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_0,
    devUrl: devUrl_0_6_0_0,
    prodUrl: prodUrl_0_6_0_0,
    path: '/zlb/api/pay/bankCard/official/nb/consumer-record',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayBankCardOfficialNbConsumerRecordPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [宁波公务卡消费记录查询↗](http://yapi.cai-inc.com/project/3075/interface/api/455146) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/nb/consumer-record`
 * @更新时间 `2024-06-13 15:57:45`
 * @项目ID 3075
 */
export const zlbApiPayBankCardOfficialNbConsumerRecordPost = /*#__PURE__*/ (
  requestData: ZlbApiPayBankCardOfficialNbConsumerRecordPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankCardOfficialNbConsumerRecordPostResponse>(
    prepare(zlbApiPayBankCardOfficialNbConsumerRecordPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankCardOfficialNbConsumerRecordPost.requestConfig =
  zlbApiPayBankCardOfficialNbConsumerRecordPostRequestConfig;

/**
 * 接口 [查询对私账户（个人卡、公务卡、外部人员、司机）↗](http://yapi.cai-inc.com/project/3075/interface/api/569266) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/private/page`
 * @更新时间 `2024-06-13 15:57:45`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardPrivatePagePostRequest {
  /**
   * 操作员id集合
   */
  operatorIdList?: number[];
  /**
   * 账户类型集合
   */
  accountTypeList?: number[];
  pageSize?: number;
  pageNo?: number;
  sortField?: string;
  sortBy?: string;
}

/**
 * 接口 [查询对私账户（个人卡、公务卡、外部人员、司机）↗](http://yapi.cai-inc.com/project/3075/interface/api/569266) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/private/page`
 * @更新时间 `2024-06-13 15:57:45`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardPrivatePagePostResponse {
  success?: boolean;
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 主键
       */
      id?: number;
      /**
       * 平台账户唯一编号
       */
      accountCode?: string;
      /**
       * 公务卡三方账户id，唯一主键，用来分析和排查是否重复拉取问题
       */
      thirdAccountCode?: string;
      /**
       * 用户id
       */
      userId?: number;
      /**
       * 用户机构id
       */
      userOrgId?: number;
      /**
       * 用户名称
       */
      userName?: string;
      /**
       * 财政区划代码
       */
      finaDivCode?: string;
      /**
       * 单位代码
       */
      companyCode?: string;
      /**
       * 单位名称
       */
      companyName?: string;
      /**
       * 银行区域代码
       */
      bankAreaCode?: string;
      /**
       * 银行代码
       */
      bankCode?: string;
      /**
       * 银行行号
       */
      bankNo?: string;
      /**
       * 银行名称
       */
      bankName?: string;
      /**
       * 开户城市
       */
      bankCity?: string;
      /**
       * 银行支行名称
       */
      bankBranchName?: string;
      /**
       * 银行账户
       */
      accountNo?: string;
      /**
       * 不拖敏
       */
      accountNoWithoutDes?: string;
      /**
       * 账户名称
       */
      accountName?: string;
      /**
       * 账户状态：0-未启用；1-启用
       */
      accountStatus?: number;
      /**
       * 账户类型：1-公务卡；2-普通银行卡；3-单位工资卡；4-对公供应商银行卡；5-对私供销商银行卡 6-单位账户
       */
      accountType?: number;
      /**
       * 账户类型名称
       */
      accountTypeName?: string;
      /**
       * 账户类型：1-个人；2-单位
       */
      accountLevel?: number;
      /**
       * 账户类型名称
       */
      accountLevelName?: string;
      /**
       * 是否默认账户：0-否；1-是
       */
      isDefault?: number;
      /**
       * 支付状态 0：未支付 1:已支付
       */
      isPay?: number;
      /**
       * 备案状态，0：未备案 1：备案成功 2：备案失败，参照：{link FilingStatusEnum}
       */
      filingStatus?: number;
      /**
       * 备案过期时间
       */
      expireDate?: string;
      /**
       * 备注
       */
      remark?: string;
      /**
       * 用户ID
       */
      operatorId?: number;
      /**
       * 开户支行别名
       */
      bankBranchAliasName?: string;
      /**
       * 收款人身份证号
       */
      receiveIdNumber?: string;
    }[];
    /**
     * 第几页
     */
    pageNum?: number;
    /**
     * 每页记录数
     */
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 当前页的数量 <= pageSize，该属性来自ArrayList的size属性
     */
    size?: number;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [查询对私账户（个人卡、公务卡、外部人员、司机）↗](http://yapi.cai-inc.com/project/3075/interface/api/569266) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/private/page`
 * @更新时间 `2024-06-13 15:57:45`
 * @项目ID 3075
 */
type ZlbApiPayBankCardPrivatePagePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bankCard/private/page',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询对私账户（个人卡、公务卡、外部人员、司机）↗](http://yapi.cai-inc.com/project/3075/interface/api/569266) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/private/page`
 * @更新时间 `2024-06-13 15:57:45`
 * @项目ID 3075
 */
const zlbApiPayBankCardPrivatePagePostRequestConfig: ZlbApiPayBankCardPrivatePagePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_0,
    devUrl: devUrl_0_6_0_0,
    prodUrl: prodUrl_0_6_0_0,
    path: '/zlb/api/pay/bankCard/private/page',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayBankCardPrivatePagePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询对私账户（个人卡、公务卡、外部人员、司机）↗](http://yapi.cai-inc.com/project/3075/interface/api/569266) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/private/page`
 * @更新时间 `2024-06-13 15:57:45`
 * @项目ID 3075
 */
export const zlbApiPayBankCardPrivatePagePost = /*#__PURE__*/ (
  requestData: ZlbApiPayBankCardPrivatePagePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankCardPrivatePagePostResponse>(
    prepare(zlbApiPayBankCardPrivatePagePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankCardPrivatePagePost.requestConfig = zlbApiPayBankCardPrivatePagePostRequestConfig;

/**
 * 接口 [公务卡导出↗](http://yapi.cai-inc.com/project/3075/interface/api/664994) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/list/export`
 * @更新时间 `2024-06-13 15:57:44`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOfficialListExportPostRequest {
  /**
   * 前端：持卡人姓名 后端：账户名称
   */
  accountName?: string;
  /**
   * 银行账号
   */
  accountNo?: string;
  /**
   * 绑定状态：0-未绑定；1-已绑定
   */
  bindStatus?: number;
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
}

/**
 * 接口 [公务卡导出↗](http://yapi.cai-inc.com/project/3075/interface/api/664994) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/list/export`
 * @更新时间 `2024-06-13 15:57:44`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOfficialListExportPostResponse {
  success?: boolean;
  result?: string;
  code?: string;
  message?: string;
}

/**
 * 接口 [公务卡导出↗](http://yapi.cai-inc.com/project/3075/interface/api/664994) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/list/export`
 * @更新时间 `2024-06-13 15:57:44`
 * @项目ID 3075
 */
type ZlbApiPayBankCardOfficialListExportPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bankCard/official/list/export',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [公务卡导出↗](http://yapi.cai-inc.com/project/3075/interface/api/664994) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/list/export`
 * @更新时间 `2024-06-13 15:57:44`
 * @项目ID 3075
 */
const zlbApiPayBankCardOfficialListExportPostRequestConfig: ZlbApiPayBankCardOfficialListExportPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_0,
    devUrl: devUrl_0_6_0_0,
    prodUrl: prodUrl_0_6_0_0,
    path: '/zlb/api/pay/bankCard/official/list/export',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayBankCardOfficialListExportPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [公务卡导出↗](http://yapi.cai-inc.com/project/3075/interface/api/664994) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `POST /zlb/api/pay/bankCard/official/list/export`
 * @更新时间 `2024-06-13 15:57:44`
 * @项目ID 3075
 */
export const zlbApiPayBankCardOfficialListExportPost = /*#__PURE__*/ (
  requestData: ZlbApiPayBankCardOfficialListExportPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankCardOfficialListExportPostResponse>(
    prepare(zlbApiPayBankCardOfficialListExportPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankCardOfficialListExportPost.requestConfig =
  zlbApiPayBankCardOfficialListExportPostRequestConfig;

/**
 * 接口 [获取导出结果↗](http://yapi.cai-inc.com/project/3075/interface/api/665002) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `GET /zlb/api/pay/bankCard/official/list/export/result`
 * @更新时间 `2024-06-13 15:57:44`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOfficialListExportResultGetRequest {
  /**
   * 任务编码
   */
  serialCode: string;
}

/**
 * 接口 [获取导出结果↗](http://yapi.cai-inc.com/project/3075/interface/api/665002) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `GET /zlb/api/pay/bankCard/official/list/export/result`
 * @更新时间 `2024-06-13 15:57:44`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOfficialListExportResultGetResponse {
  success?: boolean;
  result?: {
    /**
     * 总数
     */
    totalNum?: number;
    /**
     * 成功数量
     */
    successNum?: number;
    /**
     * 失败数量
     */
    failNum?: number;
    /**
     * 成功FileId
     */
    successFileId?: string;
    /**
     * 任务状态
     */
    status?: number;
    /**
     * 任务编号
     */
    serialCode?: string;
    message?: string;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [获取导出结果↗](http://yapi.cai-inc.com/project/3075/interface/api/665002) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `GET /zlb/api/pay/bankCard/official/list/export/result`
 * @更新时间 `2024-06-13 15:57:44`
 * @项目ID 3075
 */
type ZlbApiPayBankCardOfficialListExportResultGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bankCard/official/list/export/result',
    'data',
    string,
    'serialCode',
    false
  >
>;

/**
 * 接口 [获取导出结果↗](http://yapi.cai-inc.com/project/3075/interface/api/665002) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `GET /zlb/api/pay/bankCard/official/list/export/result`
 * @更新时间 `2024-06-13 15:57:44`
 * @项目ID 3075
 */
const zlbApiPayBankCardOfficialListExportResultGetRequestConfig: ZlbApiPayBankCardOfficialListExportResultGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_0,
    devUrl: devUrl_0_6_0_0,
    prodUrl: prodUrl_0_6_0_0,
    path: '/zlb/api/pay/bankCard/official/list/export/result',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_0,
    paramNames: [],
    queryNames: ['serialCode'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayBankCardOfficialListExportResultGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取导出结果↗](http://yapi.cai-inc.com/project/3075/interface/api/665002) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [公务卡和个人银行卡↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_48930)
 * @请求头 `GET /zlb/api/pay/bankCard/official/list/export/result`
 * @更新时间 `2024-06-13 15:57:44`
 * @项目ID 3075
 */
export const zlbApiPayBankCardOfficialListExportResultGet = /*#__PURE__*/ (
  requestData: ZlbApiPayBankCardOfficialListExportResultGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankCardOfficialListExportResultGetResponse>(
    prepare(zlbApiPayBankCardOfficialListExportResultGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankCardOfficialListExportResultGet.requestConfig =
  zlbApiPayBankCardOfficialListExportResultGetRequestConfig;

const mockUrl_0_6_0_1 = 'http://yapi.cai-inc.com/mock/3075' as any;
const devUrl_0_6_0_1 = '' as any;
const prodUrl_0_6_0_1 = '' as any;
const dataKey_0_6_0_1 = 'data' as any;

/**
 * 接口 [获取宁波支付方式↗](http://yapi.cai-inc.com/project/3075/interface/api/455154) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [OptionController↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51627)
 * @请求头 `POST /zlb/api/pay/option/get-nb-pay-type`
 * @更新时间 `2023-04-21 17:24:56`
 * @项目ID 3075
 */
export interface ZlbApiPayOptionGetNbPayTypePostRequest {}

/**
 * 接口 [获取宁波支付方式↗](http://yapi.cai-inc.com/project/3075/interface/api/455154) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [OptionController↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51627)
 * @请求头 `POST /zlb/api/pay/option/get-nb-pay-type`
 * @更新时间 `2023-04-21 17:24:56`
 * @项目ID 3075
 */
export interface ZlbApiPayOptionGetNbPayTypePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    payChannelList?: {
      /**
       * 支付渠道
       */
      payMode?: 1 | 2;
      /**
       * 支付渠道名称
       */
      payModeName?: string;
      /**
       * 支付方式集合
       */
      payTypeList?: {
        /**
         * 支付方式编码
         */
        payType?: 11 | 12 | 3;
        /**
         * 支付方式名称
         */
        payTypeName?: string;
      }[];
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [获取宁波支付方式↗](http://yapi.cai-inc.com/project/3075/interface/api/455154) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [OptionController↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51627)
 * @请求头 `POST /zlb/api/pay/option/get-nb-pay-type`
 * @更新时间 `2023-04-21 17:24:56`
 * @项目ID 3075
 */
type ZlbApiPayOptionGetNbPayTypePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/option/get-nb-pay-type',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取宁波支付方式↗](http://yapi.cai-inc.com/project/3075/interface/api/455154) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [OptionController↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51627)
 * @请求头 `POST /zlb/api/pay/option/get-nb-pay-type`
 * @更新时间 `2023-04-21 17:24:56`
 * @项目ID 3075
 */
const zlbApiPayOptionGetNbPayTypePostRequestConfig: ZlbApiPayOptionGetNbPayTypePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_1,
    devUrl: devUrl_0_6_0_1,
    prodUrl: prodUrl_0_6_0_1,
    path: '/zlb/api/pay/option/get-nb-pay-type',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.none,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayOptionGetNbPayTypePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取宁波支付方式↗](http://yapi.cai-inc.com/project/3075/interface/api/455154) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [OptionController↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51627)
 * @请求头 `POST /zlb/api/pay/option/get-nb-pay-type`
 * @更新时间 `2023-04-21 17:24:56`
 * @项目ID 3075
 */
export const zlbApiPayOptionGetNbPayTypePost = /*#__PURE__*/ (
  requestData?: ZlbApiPayOptionGetNbPayTypePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayOptionGetNbPayTypePostResponse>(
    prepare(zlbApiPayOptionGetNbPayTypePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayOptionGetNbPayTypePost.requestConfig = zlbApiPayOptionGetNbPayTypePostRequestConfig;

/**
 * 接口 [获取现金结报-报销内容列表↗](http://yapi.cai-inc.com/project/3075/interface/api/455162) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [OptionController↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51627)
 * @请求头 `POST /zlb/api/pay/option/get-nb-op-type`
 * @更新时间 `2023-04-21 17:24:56`
 * @项目ID 3075
 */
export interface ZlbApiPayOptionGetNbOpTypePostRequest {}

/**
 * 接口 [获取现金结报-报销内容列表↗](http://yapi.cai-inc.com/project/3075/interface/api/455162) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [OptionController↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51627)
 * @请求头 `POST /zlb/api/pay/option/get-nb-op-type`
 * @更新时间 `2023-04-21 17:24:56`
 * @项目ID 3075
 */
export interface ZlbApiPayOptionGetNbOpTypePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    opTypeList?: {
      /**
       * 现金结报类型
       */
      opType?: string;
      /**
       * 现金结报类型名
       */
      opTypeName?: string;
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [获取现金结报-报销内容列表↗](http://yapi.cai-inc.com/project/3075/interface/api/455162) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [OptionController↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51627)
 * @请求头 `POST /zlb/api/pay/option/get-nb-op-type`
 * @更新时间 `2023-04-21 17:24:56`
 * @项目ID 3075
 */
type ZlbApiPayOptionGetNbOpTypePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/option/get-nb-op-type',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取现金结报-报销内容列表↗](http://yapi.cai-inc.com/project/3075/interface/api/455162) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [OptionController↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51627)
 * @请求头 `POST /zlb/api/pay/option/get-nb-op-type`
 * @更新时间 `2023-04-21 17:24:56`
 * @项目ID 3075
 */
const zlbApiPayOptionGetNbOpTypePostRequestConfig: ZlbApiPayOptionGetNbOpTypePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_1,
    devUrl: devUrl_0_6_0_1,
    prodUrl: prodUrl_0_6_0_1,
    path: '/zlb/api/pay/option/get-nb-op-type',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.none,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayOptionGetNbOpTypePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取现金结报-报销内容列表↗](http://yapi.cai-inc.com/project/3075/interface/api/455162) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [OptionController↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51627)
 * @请求头 `POST /zlb/api/pay/option/get-nb-op-type`
 * @更新时间 `2023-04-21 17:24:56`
 * @项目ID 3075
 */
export const zlbApiPayOptionGetNbOpTypePost = /*#__PURE__*/ (
  requestData?: ZlbApiPayOptionGetNbOpTypePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayOptionGetNbOpTypePostResponse>(
    prepare(zlbApiPayOptionGetNbOpTypePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayOptionGetNbOpTypePost.requestConfig = zlbApiPayOptionGetNbOpTypePostRequestConfig;

const mockUrl_0_6_0_2 = 'http://yapi.cai-inc.com/mock/3075' as any;
const devUrl_0_6_0_2 = '' as any;
const prodUrl_0_6_0_2 = '' as any;
const dataKey_0_6_0_2 = 'data' as any;

/**
 * 接口 [编辑银行账户↗](http://yapi.cai-inc.com/project/3075/interface/api/204694) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [机构单位账号↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51865)
 * @请求头 `POST /zlb/api/pay/bankCard/edit`
 * @更新时间 `2024-12-30 14:17:59`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardEditPostRequest {
  /**
   * 账号编码
   */
  accountCode?: string;
  /**
   * 备注
   */
  remark?: string;
  accountLevel?: number;
}

/**
 * 接口 [编辑银行账户↗](http://yapi.cai-inc.com/project/3075/interface/api/204694) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [机构单位账号↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51865)
 * @请求头 `POST /zlb/api/pay/bankCard/edit`
 * @更新时间 `2024-12-30 14:17:59`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardEditPostResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [编辑银行账户↗](http://yapi.cai-inc.com/project/3075/interface/api/204694) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [机构单位账号↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51865)
 * @请求头 `POST /zlb/api/pay/bankCard/edit`
 * @更新时间 `2024-12-30 14:17:59`
 * @项目ID 3075
 */
type ZlbApiPayBankCardEditPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bankCard/edit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [编辑银行账户↗](http://yapi.cai-inc.com/project/3075/interface/api/204694) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [机构单位账号↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51865)
 * @请求头 `POST /zlb/api/pay/bankCard/edit`
 * @更新时间 `2024-12-30 14:17:59`
 * @项目ID 3075
 */
const zlbApiPayBankCardEditPostRequestConfig: ZlbApiPayBankCardEditPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_2,
    devUrl: devUrl_0_6_0_2,
    prodUrl: prodUrl_0_6_0_2,
    path: '/zlb/api/pay/bankCard/edit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayBankCardEditPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [编辑银行账户↗](http://yapi.cai-inc.com/project/3075/interface/api/204694) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [机构单位账号↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51865)
 * @请求头 `POST /zlb/api/pay/bankCard/edit`
 * @更新时间 `2024-12-30 14:17:59`
 * @项目ID 3075
 */
export const zlbApiPayBankCardEditPost = /*#__PURE__*/ (
  requestData: ZlbApiPayBankCardEditPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankCardEditPostResponse>(
    prepare(zlbApiPayBankCardEditPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankCardEditPost.requestConfig = zlbApiPayBankCardEditPostRequestConfig;

/**
 * 接口 [获取单位账户列表↗](http://yapi.cai-inc.com/project/3075/interface/api/253070) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [机构单位账号↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51865)
 * @请求头 `POST /zlb/api/pay/bankCard/org/list`
 * @更新时间 `2024-12-30 14:17:58`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOrgListPostRequest {
  /**
   * 银行卡号
   */
  bankCardNo?: string;
  /**
   * 账户类型
   */
  accountType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11;
  /**
   * 银行名字列表
   */
  bankNames?: string[];
  /**
   * 需排除的accountCode集合
   */
  excludeAccountCodes?: string[];
  /**
   * 账户level
   */
  accountLevel?: number;
  /**
   * 机构id
   */
  orgId?: number;
  /**
   * 账户level list
   */
  accountLevelList?: number[];
  /**
   * 账号模糊查询
   */
  bankCardNoLike?: string;
  /**
   * 区划编码
   */
  finaDivCode?: string;
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
}

/**
 * 接口 [获取单位账户列表↗](http://yapi.cai-inc.com/project/3075/interface/api/253070) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [机构单位账号↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51865)
 * @请求头 `POST /zlb/api/pay/bankCard/org/list`
 * @更新时间 `2024-12-30 14:17:58`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOrgListPostResponse {
  success?: boolean;
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 主键
       */
      id?: number;
      /**
       * 平台账户唯一编号
       */
      accountCode?: string;
      /**
       * 公务卡三方账户id，唯一主键，用来分析和排查是否重复拉取问题
       */
      thirdAccountCode?: string;
      /**
       * 用户id
       */
      userId?: number;
      /**
       * 用户机构id
       */
      userOrgId?: number;
      /**
       * 用户名称
       */
      userName?: string;
      /**
       * 财政区划代码
       */
      finaDivCode?: string;
      /**
       * 单位代码
       */
      companyCode?: string;
      /**
       * 单位名称
       */
      companyName?: string;
      /**
       * 银行区域代码
       */
      bankAreaCode?: string;
      /**
       * 银行代码
       */
      bankCode?: string;
      /**
       * 银行行号
       */
      bankNo?: string;
      /**
       * 银行名称
       */
      bankName?: string;
      /**
       * 开户城市
       */
      bankCity?: string;
      /**
       * 银行支行名称
       */
      bankBranchName?: string;
      /**
       * 银行账户
       */
      accountNo?: string;
      /**
       * 不拖敏
       */
      accountNoWithoutDes?: string;
      /**
       * 账户名称
       */
      accountName?: string;
      /**
       * 账户状态：0-未启用；1-启用
       */
      accountStatus?: number;
      /**
       * 账户类型：1-公务卡；2-普通银行卡；3-单位工资卡；4-对公供应商银行卡；5-对私供销商银行卡 6-单位账户
       */
      accountType?: number;
      /**
       * 账户类型名称
       */
      accountTypeName?: string;
      /**
       * 账户类型：1-个人；2-单位
       */
      accountLevel?: number;
      /**
       * 账户类型名称
       */
      accountLevelName?: string;
      /**
       * 是否默认账户：0-否；1-是
       */
      isDefault?: number;
      /**
       * 支付状态 0：未支付 1:已支付
       */
      isPay?: number;
      /**
       * 备案状态，0：未备案 1：备案成功 2：备案失败，参照：{link FilingStatusEnum}
       */
      filingStatus?: number;
      /**
       * 备案过期时间
       */
      expireDate?: string;
      /**
       * 备注
       */
      remark?: string;
      /**
       * 用户ID
       */
      operatorId?: number;
      /**
       * 开户支行别名
       */
      bankBranchAliasName?: string;
      /**
       * 收款人身份证号
       */
      receiveIdNumber?: string;
      /**
       * 单位账户子类型code
       */
      orgAccountSubTypeCode?: number;
      /**
       * 单位账户子类型描述
       */
      orgAccountSubTypeDesc?: string;
      /**
       * 账户余额
       */
      accountBalance?: number;
    }[];
    /**
     * 第几页
     */
    pageNum?: number;
    /**
     * 每页记录数
     */
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 当前页的数量 <= pageSize，该属性来自ArrayList的size属性
     */
    size?: number;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [获取单位账户列表↗](http://yapi.cai-inc.com/project/3075/interface/api/253070) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [机构单位账号↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51865)
 * @请求头 `POST /zlb/api/pay/bankCard/org/list`
 * @更新时间 `2024-12-30 14:17:58`
 * @项目ID 3075
 */
type ZlbApiPayBankCardOrgListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bankCard/org/list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [获取单位账户列表↗](http://yapi.cai-inc.com/project/3075/interface/api/253070) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [机构单位账号↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51865)
 * @请求头 `POST /zlb/api/pay/bankCard/org/list`
 * @更新时间 `2024-12-30 14:17:58`
 * @项目ID 3075
 */
const zlbApiPayBankCardOrgListPostRequestConfig: ZlbApiPayBankCardOrgListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_2,
    devUrl: devUrl_0_6_0_2,
    prodUrl: prodUrl_0_6_0_2,
    path: '/zlb/api/pay/bankCard/org/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayBankCardOrgListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取单位账户列表↗](http://yapi.cai-inc.com/project/3075/interface/api/253070) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [机构单位账号↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51865)
 * @请求头 `POST /zlb/api/pay/bankCard/org/list`
 * @更新时间 `2024-12-30 14:17:58`
 * @项目ID 3075
 */
export const zlbApiPayBankCardOrgListPost = /*#__PURE__*/ (
  requestData: ZlbApiPayBankCardOrgListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankCardOrgListPostResponse>(
    prepare(zlbApiPayBankCardOrgListPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankCardOrgListPost.requestConfig = zlbApiPayBankCardOrgListPostRequestConfig;

/**
 * 接口 [添加机构单位账户↗](http://yapi.cai-inc.com/project/3075/interface/api/258306) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [机构单位账号↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51865)
 * @请求头 `POST /zlb/api/pay/bankCard/addOrgAccount`
 * @更新时间 `2024-12-30 14:17:58`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardAddOrgAccountPostRequest {
  /**
   * 银行代码，大行编码
   */
  bankCode?: string;
  /**
   * 银行名称，大行名称，例如：中国银行、工商银行，招商银行等
   */
  bankName?: string;
  /**
   * 银行行号，银行支行编号
   */
  bankNo?: string;
  /**
   * 银行支行名称，例如：中国银行下的支行名称
   */
  bankBranchName?: string;
  /**
   * 银行账户，用户输入，个人银行卡号
   */
  accountNo?: string;
  /**
   * 账户名称，即户名，用户输入，例如：个人的名字
   */
  accountName?: string;
  /**
   * 备注
   */
  remark?: string;
  /**
   * 省份编码
   */
  provinceCode?: string;
  /**
   * 省份名称
   */
  provinceName?: string;
  /**
   * 城市编码
   */
  cityCode?: string;
  /**
   * 城市名称
   */
  cityName?: string;
  /**
   * 单位账户子类型
   * #{@link AccountLevelEnum}
   */
  accountLevel?: number;
}

/**
 * 接口 [添加机构单位账户↗](http://yapi.cai-inc.com/project/3075/interface/api/258306) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [机构单位账号↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51865)
 * @请求头 `POST /zlb/api/pay/bankCard/addOrgAccount`
 * @更新时间 `2024-12-30 14:17:58`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardAddOrgAccountPostResponse {
  success?: boolean;
  result?: {};
  code?: string;
  message?: string;
}

/**
 * 接口 [添加机构单位账户↗](http://yapi.cai-inc.com/project/3075/interface/api/258306) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [机构单位账号↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51865)
 * @请求头 `POST /zlb/api/pay/bankCard/addOrgAccount`
 * @更新时间 `2024-12-30 14:17:58`
 * @项目ID 3075
 */
type ZlbApiPayBankCardAddOrgAccountPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bankCard/addOrgAccount',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [添加机构单位账户↗](http://yapi.cai-inc.com/project/3075/interface/api/258306) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [机构单位账号↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51865)
 * @请求头 `POST /zlb/api/pay/bankCard/addOrgAccount`
 * @更新时间 `2024-12-30 14:17:58`
 * @项目ID 3075
 */
const zlbApiPayBankCardAddOrgAccountPostRequestConfig: ZlbApiPayBankCardAddOrgAccountPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_2,
    devUrl: devUrl_0_6_0_2,
    prodUrl: prodUrl_0_6_0_2,
    path: '/zlb/api/pay/bankCard/addOrgAccount',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayBankCardAddOrgAccountPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [添加机构单位账户↗](http://yapi.cai-inc.com/project/3075/interface/api/258306) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [机构单位账号↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51865)
 * @请求头 `POST /zlb/api/pay/bankCard/addOrgAccount`
 * @更新时间 `2024-12-30 14:17:58`
 * @项目ID 3075
 */
export const zlbApiPayBankCardAddOrgAccountPost = /*#__PURE__*/ (
  requestData: ZlbApiPayBankCardAddOrgAccountPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankCardAddOrgAccountPostResponse>(
    prepare(zlbApiPayBankCardAddOrgAccountPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankCardAddOrgAccountPost.requestConfig = zlbApiPayBankCardAddOrgAccountPostRequestConfig;

/**
 * 接口 [获取机构默认账户集合↗](http://yapi.cai-inc.com/project/3075/interface/api/468306) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [机构单位账号↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51865)
 * @请求头 `POST /zlb/api/pay/bankCard/org/get-default-account`
 * @更新时间 `2024-12-30 14:17:59`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOrgGetDefaultAccountPostRequest {}

/**
 * 接口 [获取机构默认账户集合↗](http://yapi.cai-inc.com/project/3075/interface/api/468306) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [机构单位账号↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51865)
 * @请求头 `POST /zlb/api/pay/bankCard/org/get-default-account`
 * @更新时间 `2024-12-30 14:17:59`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOrgGetDefaultAccountPostResponse {
  success?: boolean;
  result?: {
    /**
     * 场景code
     */
    scenesCode?: string;
    /**
     * 场景名称
     */
    scenesName?: string;
    /**
     * 账户唯一code
     */
    accountCode?: string;
    /**
     * 默认账户，脱敏
     */
    accountNo?: string;
    /**
     * 银行code
     */
    bankCode?: string;
    /**
     * 银行名称
     */
    bankName?: string;
    /**
     * 按钮对象
     */
    operatorButton?: {
      /**
       * 配置按钮，true-显示，false-隐藏
       */
      configBtn?: boolean;
      /**
       * 修改按钮，true-显示，false-隐藏
       */
      modifyBtn?: boolean;
      /**
       * 重置按钮，true-显示，false-隐藏
       */
      resetBtn?: boolean;
    };
  }[];
  code?: string;
  message?: string;
}

/**
 * 接口 [获取机构默认账户集合↗](http://yapi.cai-inc.com/project/3075/interface/api/468306) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [机构单位账号↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51865)
 * @请求头 `POST /zlb/api/pay/bankCard/org/get-default-account`
 * @更新时间 `2024-12-30 14:17:59`
 * @项目ID 3075
 */
type ZlbApiPayBankCardOrgGetDefaultAccountPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bankCard/org/get-default-account',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取机构默认账户集合↗](http://yapi.cai-inc.com/project/3075/interface/api/468306) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [机构单位账号↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51865)
 * @请求头 `POST /zlb/api/pay/bankCard/org/get-default-account`
 * @更新时间 `2024-12-30 14:17:59`
 * @项目ID 3075
 */
const zlbApiPayBankCardOrgGetDefaultAccountPostRequestConfig: ZlbApiPayBankCardOrgGetDefaultAccountPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_2,
    devUrl: devUrl_0_6_0_2,
    prodUrl: prodUrl_0_6_0_2,
    path: '/zlb/api/pay/bankCard/org/get-default-account',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.none,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayBankCardOrgGetDefaultAccountPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取机构默认账户集合↗](http://yapi.cai-inc.com/project/3075/interface/api/468306) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [机构单位账号↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51865)
 * @请求头 `POST /zlb/api/pay/bankCard/org/get-default-account`
 * @更新时间 `2024-12-30 14:17:59`
 * @项目ID 3075
 */
export const zlbApiPayBankCardOrgGetDefaultAccountPost = /*#__PURE__*/ (
  requestData?: ZlbApiPayBankCardOrgGetDefaultAccountPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankCardOrgGetDefaultAccountPostResponse>(
    prepare(zlbApiPayBankCardOrgGetDefaultAccountPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankCardOrgGetDefaultAccountPost.requestConfig =
  zlbApiPayBankCardOrgGetDefaultAccountPostRequestConfig;

/**
 * 接口 [设置默认账户↗](http://yapi.cai-inc.com/project/3075/interface/api/469290) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [机构单位账号↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51865)
 * @请求头 `POST /zlb/api/pay/bankCard/org/set-default-account`
 * @更新时间 `2024-12-30 14:17:59`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOrgSetDefaultAccountPostRequest {
  /**
   * 场景code
   */
  scenesCode: string;
  /**
   * 账户唯一code
   */
  accountCode?: string;
}

/**
 * 接口 [设置默认账户↗](http://yapi.cai-inc.com/project/3075/interface/api/469290) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [机构单位账号↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51865)
 * @请求头 `POST /zlb/api/pay/bankCard/org/set-default-account`
 * @更新时间 `2024-12-30 14:17:59`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOrgSetDefaultAccountPostResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [设置默认账户↗](http://yapi.cai-inc.com/project/3075/interface/api/469290) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [机构单位账号↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51865)
 * @请求头 `POST /zlb/api/pay/bankCard/org/set-default-account`
 * @更新时间 `2024-12-30 14:17:59`
 * @项目ID 3075
 */
type ZlbApiPayBankCardOrgSetDefaultAccountPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bankCard/org/set-default-account',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [设置默认账户↗](http://yapi.cai-inc.com/project/3075/interface/api/469290) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [机构单位账号↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51865)
 * @请求头 `POST /zlb/api/pay/bankCard/org/set-default-account`
 * @更新时间 `2024-12-30 14:17:59`
 * @项目ID 3075
 */
const zlbApiPayBankCardOrgSetDefaultAccountPostRequestConfig: ZlbApiPayBankCardOrgSetDefaultAccountPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_2,
    devUrl: devUrl_0_6_0_2,
    prodUrl: prodUrl_0_6_0_2,
    path: '/zlb/api/pay/bankCard/org/set-default-account',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayBankCardOrgSetDefaultAccountPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [设置默认账户↗](http://yapi.cai-inc.com/project/3075/interface/api/469290) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [机构单位账号↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51865)
 * @请求头 `POST /zlb/api/pay/bankCard/org/set-default-account`
 * @更新时间 `2024-12-30 14:17:59`
 * @项目ID 3075
 */
export const zlbApiPayBankCardOrgSetDefaultAccountPost = /*#__PURE__*/ (
  requestData: ZlbApiPayBankCardOrgSetDefaultAccountPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankCardOrgSetDefaultAccountPostResponse>(
    prepare(zlbApiPayBankCardOrgSetDefaultAccountPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankCardOrgSetDefaultAccountPost.requestConfig =
  zlbApiPayBankCardOrgSetDefaultAccountPostRequestConfig;

/**
 * 接口 [tuoshouAccountCheckUnique↗](http://yapi.cai-inc.com/project/3075/interface/api/710442) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [机构单位账号↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51865)
 * @请求头 `POST /zlb/api/pay/bankCard/org/check`
 * @更新时间 `2024-12-30 14:17:58`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOrgCheckPostRequest {
  accountLevel?: number;
}

/**
 * 接口 [tuoshouAccountCheckUnique↗](http://yapi.cai-inc.com/project/3075/interface/api/710442) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [机构单位账号↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51865)
 * @请求头 `POST /zlb/api/pay/bankCard/org/check`
 * @更新时间 `2024-12-30 14:17:58`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardOrgCheckPostResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [tuoshouAccountCheckUnique↗](http://yapi.cai-inc.com/project/3075/interface/api/710442) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [机构单位账号↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51865)
 * @请求头 `POST /zlb/api/pay/bankCard/org/check`
 * @更新时间 `2024-12-30 14:17:58`
 * @项目ID 3075
 */
type ZlbApiPayBankCardOrgCheckPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bankCard/org/check',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [tuoshouAccountCheckUnique↗](http://yapi.cai-inc.com/project/3075/interface/api/710442) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [机构单位账号↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51865)
 * @请求头 `POST /zlb/api/pay/bankCard/org/check`
 * @更新时间 `2024-12-30 14:17:58`
 * @项目ID 3075
 */
const zlbApiPayBankCardOrgCheckPostRequestConfig: ZlbApiPayBankCardOrgCheckPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_2,
    devUrl: devUrl_0_6_0_2,
    prodUrl: prodUrl_0_6_0_2,
    path: '/zlb/api/pay/bankCard/org/check',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayBankCardOrgCheckPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [tuoshouAccountCheckUnique↗](http://yapi.cai-inc.com/project/3075/interface/api/710442) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [机构单位账号↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51865)
 * @请求头 `POST /zlb/api/pay/bankCard/org/check`
 * @更新时间 `2024-12-30 14:17:58`
 * @项目ID 3075
 */
export const zlbApiPayBankCardOrgCheckPost = /*#__PURE__*/ (
  requestData: ZlbApiPayBankCardOrgCheckPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankCardOrgCheckPostResponse>(
    prepare(zlbApiPayBankCardOrgCheckPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankCardOrgCheckPost.requestConfig = zlbApiPayBankCardOrgCheckPostRequestConfig;

/**
 * 接口 [添加财政零余额账户↗](http://yapi.cai-inc.com/project/3075/interface/api/710450) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [机构单位账号↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51865)
 * @请求头 `POST /zlb/api/pay/bankCard/addFinancialAccount`
 * @更新时间 `2024-12-30 14:17:59`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardAddFinancialAccountPostRequest {
  /**
   * 统一社会信用代码
   */
  creditCode?: string;
  /**
   * 银行代码，大行编码
   */
  bankCode?: string;
  /**
   * 银行名称，大行名称，例如：中国银行、工商银行，招商银行等
   */
  bankName?: string;
  /**
   * 银行行号，银行支行编号
   */
  bankNo?: string;
  /**
   * 银行支行名称，例如：中国银行下的支行名称
   */
  bankBranchName?: string;
  /**
   * 银行账户，用户输入，个人银行卡号
   */
  accountNo?: string;
  /**
   * 账户名称，即户名，用户输入，例如：个人的名字
   */
  accountName?: string;
  /**
   * 备注
   */
  remark?: string;
  /**
   * 省份编码
   */
  provinceCode?: string;
  /**
   * 省份名称
   */
  provinceName?: string;
  /**
   * 城市编码
   */
  cityCode?: string;
  /**
   * 城市名称
   */
  cityName?: string;
  /**
   * 单位账户子类型
   * #{@link AccountLevelEnum}
   */
  accountLevel?: number;
}

/**
 * 接口 [添加财政零余额账户↗](http://yapi.cai-inc.com/project/3075/interface/api/710450) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [机构单位账号↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51865)
 * @请求头 `POST /zlb/api/pay/bankCard/addFinancialAccount`
 * @更新时间 `2024-12-30 14:17:59`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardAddFinancialAccountPostResponse {
  success?: boolean;
  result?: number;
  code?: string;
  message?: string;
}

/**
 * 接口 [添加财政零余额账户↗](http://yapi.cai-inc.com/project/3075/interface/api/710450) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [机构单位账号↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51865)
 * @请求头 `POST /zlb/api/pay/bankCard/addFinancialAccount`
 * @更新时间 `2024-12-30 14:17:59`
 * @项目ID 3075
 */
type ZlbApiPayBankCardAddFinancialAccountPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bankCard/addFinancialAccount',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [添加财政零余额账户↗](http://yapi.cai-inc.com/project/3075/interface/api/710450) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [机构单位账号↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51865)
 * @请求头 `POST /zlb/api/pay/bankCard/addFinancialAccount`
 * @更新时间 `2024-12-30 14:17:59`
 * @项目ID 3075
 */
const zlbApiPayBankCardAddFinancialAccountPostRequestConfig: ZlbApiPayBankCardAddFinancialAccountPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_2,
    devUrl: devUrl_0_6_0_2,
    prodUrl: prodUrl_0_6_0_2,
    path: '/zlb/api/pay/bankCard/addFinancialAccount',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayBankCardAddFinancialAccountPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [添加财政零余额账户↗](http://yapi.cai-inc.com/project/3075/interface/api/710450) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [机构单位账号↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51865)
 * @请求头 `POST /zlb/api/pay/bankCard/addFinancialAccount`
 * @更新时间 `2024-12-30 14:17:59`
 * @项目ID 3075
 */
export const zlbApiPayBankCardAddFinancialAccountPost = /*#__PURE__*/ (
  requestData: ZlbApiPayBankCardAddFinancialAccountPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankCardAddFinancialAccountPostResponse>(
    prepare(zlbApiPayBankCardAddFinancialAccountPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankCardAddFinancialAccountPost.requestConfig =
  zlbApiPayBankCardAddFinancialAccountPostRequestConfig;

/**
 * 接口 [托收账户更换↗](http://yapi.cai-inc.com/project/3075/interface/api/710466) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [机构单位账号↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51865)
 * @请求头 `POST /zlb/api/pay/bankCard/transferTuoshouAccount`
 * @更新时间 `2024-12-30 14:17:58`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardTransferTuoshouAccountPostRequest {
  /**
   * 银行代码，大行编码
   */
  bankCode?: string;
  /**
   * 银行名称，大行名称，例如：中国银行、工商银行，招商银行等
   */
  bankName?: string;
  /**
   * 银行行号，银行支行编号
   */
  bankNo?: string;
  /**
   * 银行支行名称，例如：中国银行下的支行名称
   */
  bankBranchName?: string;
  /**
   * 银行账户，用户输入，个人银行卡号
   */
  accountNo?: string;
  /**
   * 账户名称，即户名，用户输入，例如：个人的名字
   */
  accountName?: string;
  /**
   * 备注
   */
  remark?: string;
  /**
   * 省份编码
   */
  provinceCode?: string;
  /**
   * 省份名称
   */
  provinceName?: string;
  /**
   * 城市编码
   */
  cityCode?: string;
  /**
   * 城市名称
   */
  cityName?: string;
  /**
   * 单位账户子类型
   * #{@link AccountLevelEnum}
   */
  accountLevel?: number;
}

/**
 * 接口 [托收账户更换↗](http://yapi.cai-inc.com/project/3075/interface/api/710466) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [机构单位账号↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51865)
 * @请求头 `POST /zlb/api/pay/bankCard/transferTuoshouAccount`
 * @更新时间 `2024-12-30 14:17:58`
 * @项目ID 3075
 */
export interface ZlbApiPayBankCardTransferTuoshouAccountPostResponse {
  success?: boolean;
  result?: {};
  code?: string;
  message?: string;
}

/**
 * 接口 [托收账户更换↗](http://yapi.cai-inc.com/project/3075/interface/api/710466) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [机构单位账号↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51865)
 * @请求头 `POST /zlb/api/pay/bankCard/transferTuoshouAccount`
 * @更新时间 `2024-12-30 14:17:58`
 * @项目ID 3075
 */
type ZlbApiPayBankCardTransferTuoshouAccountPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bankCard/transferTuoshouAccount',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [托收账户更换↗](http://yapi.cai-inc.com/project/3075/interface/api/710466) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [机构单位账号↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51865)
 * @请求头 `POST /zlb/api/pay/bankCard/transferTuoshouAccount`
 * @更新时间 `2024-12-30 14:17:58`
 * @项目ID 3075
 */
const zlbApiPayBankCardTransferTuoshouAccountPostRequestConfig: ZlbApiPayBankCardTransferTuoshouAccountPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_2,
    devUrl: devUrl_0_6_0_2,
    prodUrl: prodUrl_0_6_0_2,
    path: '/zlb/api/pay/bankCard/transferTuoshouAccount',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayBankCardTransferTuoshouAccountPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [托收账户更换↗](http://yapi.cai-inc.com/project/3075/interface/api/710466) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [机构单位账号↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_51865)
 * @请求头 `POST /zlb/api/pay/bankCard/transferTuoshouAccount`
 * @更新时间 `2024-12-30 14:17:58`
 * @项目ID 3075
 */
export const zlbApiPayBankCardTransferTuoshouAccountPost = /*#__PURE__*/ (
  requestData: ZlbApiPayBankCardTransferTuoshouAccountPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankCardTransferTuoshouAccountPostResponse>(
    prepare(zlbApiPayBankCardTransferTuoshouAccountPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankCardTransferTuoshouAccountPost.requestConfig =
  zlbApiPayBankCardTransferTuoshouAccountPostRequestConfig;

const mockUrl_0_6_0_3 = 'http://yapi.cai-inc.com/mock/3075' as any;
const devUrl_0_6_0_3 = '' as any;
const prodUrl_0_6_0_3 = '' as any;
const dataKey_0_6_0_3 = 'data' as any;

/**
 * 接口 [分页搜索查询列表↗](http://yapi.cai-inc.com/project/3075/interface/api/475314) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `GET /zlb/api/pay/bank/receipt/list`
 * @更新时间 `2023-12-19 19:49:51`
 * @项目ID 3075
 */
export interface ZlbApiPayBankReceiptListGetRequest {
  /**
   * 银行回单编号
   */
  bankReceiptCode?: string;
  /**
   * 创建开始时间
   */
  createStartTime?: string;
  /**
   * 创建结束时间
   */
  createEndTime?: string;
  /**
   * 报销业务单据号
   */
  expenseBusinessCode?: string;
  /**
   * 是否属于浙里报
   */
  isZlb?: string;
  /**
   * 组织id
   */
  orgId?: string;
  /**
   * 银行代码
   */
  bankType?: string;
  /**
   * 付款账户是否需要脱敏
   */
  payerAccountNeedDesensitize?: string;
  /**
   * 收款账户是否需要脱敏
   */
  payeeAccountNeedDesensitize?: string;
  /**
   * 页面大小
   */
  pageSize?: string;
  /**
   * 页码
   */
  pageNo?: string;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
}

/**
 * 接口 [分页搜索查询列表↗](http://yapi.cai-inc.com/project/3075/interface/api/475314) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `GET /zlb/api/pay/bank/receipt/list`
 * @更新时间 `2023-12-19 19:49:51`
 * @项目ID 3075
 */
export interface ZlbApiPayBankReceiptListGetResponse {
  success?: boolean;
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 银行回单凭证id
       */
      voucherId?: string;
      /**
       * 银行回单编号
       */
      bankReceiptCode?: string;
      /**
       * 银行回单图片
       */
      fileUrl?: string;
      /**
       * 创建时间-时间戳
       */
      createTime?: number;
      /**
       * 币种，1-人民币
       */
      concurrency?: string;
      /**
       * 金额
       */
      amount?: number;
      /**
       * 收款人户名
       */
      payeeAccountName?: string;
      /**
       * 收款人账户
       */
      payeeAccountNo?: string;
      /**
       * 付款人开户行
       */
      payeeBankName?: string;
      /**
       * 付款人户名
       */
      payerAccountName?: string;
      /**
       * 付款人账户
       */
      payerAccountNo?: string;
      /**
       * 收款人开户行
       */
      payerBankName?: string;
      /**
       * 报销单业务单据号
       */
      businessFormCode?: string;
      /**
       * 报销单业务唯一编码
       */
      expenseFormCode?: string;
      /**
       * 是否属于浙里报,0-否，1-是
       */
      isZlb?: number;
      /**
       * 银行代码
       */
      bankType?: string;
      /**
       * 银行代码描述
       */
      bankTypeDesc?: string;
      /**
       * 关联记账凭证状态
       * 0：不可关联
       * 1：可关联
       * 2：已关联
       */
      relationStatus?: number;
      /**
       * 关联按钮
       */
      relationButton?: boolean;
    }[];
    /**
     * 第几页
     */
    pageNum?: number;
    /**
     * 每页记录数
     */
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 当前页的数量 <= pageSize，该属性来自ArrayList的size属性
     */
    size?: number;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [分页搜索查询列表↗](http://yapi.cai-inc.com/project/3075/interface/api/475314) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `GET /zlb/api/pay/bank/receipt/list`
 * @更新时间 `2023-12-19 19:49:51`
 * @项目ID 3075
 */
type ZlbApiPayBankReceiptListGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bank/receipt/list',
    'data',
    string,
    | 'bankReceiptCode'
    | 'createStartTime'
    | 'createEndTime'
    | 'expenseBusinessCode'
    | 'isZlb'
    | 'orgId'
    | 'bankType'
    | 'payerAccountNeedDesensitize'
    | 'payeeAccountNeedDesensitize'
    | 'pageSize'
    | 'pageNo'
    | 'sortField'
    | 'sortBy',
    false
  >
>;

/**
 * 接口 [分页搜索查询列表↗](http://yapi.cai-inc.com/project/3075/interface/api/475314) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `GET /zlb/api/pay/bank/receipt/list`
 * @更新时间 `2023-12-19 19:49:51`
 * @项目ID 3075
 */
const zlbApiPayBankReceiptListGetRequestConfig: ZlbApiPayBankReceiptListGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_3,
    devUrl: devUrl_0_6_0_3,
    prodUrl: prodUrl_0_6_0_3,
    path: '/zlb/api/pay/bank/receipt/list',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_3,
    paramNames: [],
    queryNames: [
      'bankReceiptCode',
      'createStartTime',
      'createEndTime',
      'expenseBusinessCode',
      'isZlb',
      'orgId',
      'bankType',
      'payerAccountNeedDesensitize',
      'payeeAccountNeedDesensitize',
      'pageSize',
      'pageNo',
      'sortField',
      'sortBy',
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayBankReceiptListGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [分页搜索查询列表↗](http://yapi.cai-inc.com/project/3075/interface/api/475314) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `GET /zlb/api/pay/bank/receipt/list`
 * @更新时间 `2023-12-19 19:49:51`
 * @项目ID 3075
 */
export const zlbApiPayBankReceiptListGet = /*#__PURE__*/ (
  requestData: ZlbApiPayBankReceiptListGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankReceiptListGetResponse>(
    prepare(zlbApiPayBankReceiptListGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankReceiptListGet.requestConfig = zlbApiPayBankReceiptListGetRequestConfig;

/**
 * 接口 [获取银行类型列表↗](http://yapi.cai-inc.com/project/3075/interface/api/475322) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `GET /zlb/api/pay/bank/receipt/type-list`
 * @更新时间 `2023-12-19 19:49:51`
 * @项目ID 3075
 */
export interface ZlbApiPayBankReceiptTypeListGetRequest {}

/**
 * 接口 [获取银行类型列表↗](http://yapi.cai-inc.com/project/3075/interface/api/475322) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `GET /zlb/api/pay/bank/receipt/type-list`
 * @更新时间 `2023-12-19 19:49:51`
 * @项目ID 3075
 */
export interface ZlbApiPayBankReceiptTypeListGetResponse {
  success?: boolean;
  result?: {
    /**
     * 银行代码
     */
    bankCode?: string;
    /**
     * 银行名字
     */
    bankName?: string;
  }[];
  code?: string;
  message?: string;
}

/**
 * 接口 [获取银行类型列表↗](http://yapi.cai-inc.com/project/3075/interface/api/475322) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `GET /zlb/api/pay/bank/receipt/type-list`
 * @更新时间 `2023-12-19 19:49:51`
 * @项目ID 3075
 */
type ZlbApiPayBankReceiptTypeListGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bank/receipt/type-list',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取银行类型列表↗](http://yapi.cai-inc.com/project/3075/interface/api/475322) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `GET /zlb/api/pay/bank/receipt/type-list`
 * @更新时间 `2023-12-19 19:49:51`
 * @项目ID 3075
 */
const zlbApiPayBankReceiptTypeListGetRequestConfig: ZlbApiPayBankReceiptTypeListGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_3,
    devUrl: devUrl_0_6_0_3,
    prodUrl: prodUrl_0_6_0_3,
    path: '/zlb/api/pay/bank/receipt/type-list',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayBankReceiptTypeListGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取银行类型列表↗](http://yapi.cai-inc.com/project/3075/interface/api/475322) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `GET /zlb/api/pay/bank/receipt/type-list`
 * @更新时间 `2023-12-19 19:49:51`
 * @项目ID 3075
 */
export const zlbApiPayBankReceiptTypeListGet = /*#__PURE__*/ (
  requestData?: ZlbApiPayBankReceiptTypeListGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankReceiptTypeListGetResponse>(
    prepare(zlbApiPayBankReceiptTypeListGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankReceiptTypeListGet.requestConfig = zlbApiPayBankReceiptTypeListGetRequestConfig;

/**
 * 接口 [银行回单主动拉取↗](http://yapi.cai-inc.com/project/3075/interface/api/475330) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `POST /zlb/api/pay/bank/receipt/sync/pull`
 * @更新时间 `2023-12-19 19:49:51`
 * @项目ID 3075
 */
export interface ZlbApiPayBankReceiptSyncPullPostRequest {
  /**
   * 创建开始时间
   */
  createStartTime?: number;
  /**
   * 创建结束时间
   */
  createEndTime?: number;
}

/**
 * 接口 [银行回单主动拉取↗](http://yapi.cai-inc.com/project/3075/interface/api/475330) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `POST /zlb/api/pay/bank/receipt/sync/pull`
 * @更新时间 `2023-12-19 19:49:51`
 * @项目ID 3075
 */
export interface ZlbApiPayBankReceiptSyncPullPostResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [银行回单主动拉取↗](http://yapi.cai-inc.com/project/3075/interface/api/475330) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `POST /zlb/api/pay/bank/receipt/sync/pull`
 * @更新时间 `2023-12-19 19:49:51`
 * @项目ID 3075
 */
type ZlbApiPayBankReceiptSyncPullPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bank/receipt/sync/pull',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [银行回单主动拉取↗](http://yapi.cai-inc.com/project/3075/interface/api/475330) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `POST /zlb/api/pay/bank/receipt/sync/pull`
 * @更新时间 `2023-12-19 19:49:51`
 * @项目ID 3075
 */
const zlbApiPayBankReceiptSyncPullPostRequestConfig: ZlbApiPayBankReceiptSyncPullPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_3,
    devUrl: devUrl_0_6_0_3,
    prodUrl: prodUrl_0_6_0_3,
    path: '/zlb/api/pay/bank/receipt/sync/pull',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayBankReceiptSyncPullPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [银行回单主动拉取↗](http://yapi.cai-inc.com/project/3075/interface/api/475330) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `POST /zlb/api/pay/bank/receipt/sync/pull`
 * @更新时间 `2023-12-19 19:49:51`
 * @项目ID 3075
 */
export const zlbApiPayBankReceiptSyncPullPost = /*#__PURE__*/ (
  requestData: ZlbApiPayBankReceiptSyncPullPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankReceiptSyncPullPostResponse>(
    prepare(zlbApiPayBankReceiptSyncPullPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankReceiptSyncPullPost.requestConfig = zlbApiPayBankReceiptSyncPullPostRequestConfig;

/**
 * 接口 [是否还有拉取银行回单的任务↗](http://yapi.cai-inc.com/project/3075/interface/api/478938) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `GET /zlb/api/pay/bank/receipt/has-task`
 * @更新时间 `2023-12-19 19:49:51`
 * @项目ID 3075
 */
export interface ZlbApiPayBankReceiptHasTaskGetRequest {}

/**
 * 接口 [是否还有拉取银行回单的任务↗](http://yapi.cai-inc.com/project/3075/interface/api/478938) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `GET /zlb/api/pay/bank/receipt/has-task`
 * @更新时间 `2023-12-19 19:49:51`
 * @项目ID 3075
 */
export interface ZlbApiPayBankReceiptHasTaskGetResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [是否还有拉取银行回单的任务↗](http://yapi.cai-inc.com/project/3075/interface/api/478938) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `GET /zlb/api/pay/bank/receipt/has-task`
 * @更新时间 `2023-12-19 19:49:51`
 * @项目ID 3075
 */
type ZlbApiPayBankReceiptHasTaskGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bank/receipt/has-task',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [是否还有拉取银行回单的任务↗](http://yapi.cai-inc.com/project/3075/interface/api/478938) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `GET /zlb/api/pay/bank/receipt/has-task`
 * @更新时间 `2023-12-19 19:49:51`
 * @项目ID 3075
 */
const zlbApiPayBankReceiptHasTaskGetRequestConfig: ZlbApiPayBankReceiptHasTaskGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_3,
    devUrl: devUrl_0_6_0_3,
    prodUrl: prodUrl_0_6_0_3,
    path: '/zlb/api/pay/bank/receipt/has-task',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayBankReceiptHasTaskGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [是否还有拉取银行回单的任务↗](http://yapi.cai-inc.com/project/3075/interface/api/478938) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `GET /zlb/api/pay/bank/receipt/has-task`
 * @更新时间 `2023-12-19 19:49:51`
 * @项目ID 3075
 */
export const zlbApiPayBankReceiptHasTaskGet = /*#__PURE__*/ (
  requestData?: ZlbApiPayBankReceiptHasTaskGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankReceiptHasTaskGetResponse>(
    prepare(zlbApiPayBankReceiptHasTaskGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankReceiptHasTaskGet.requestConfig = zlbApiPayBankReceiptHasTaskGetRequestConfig;

/**
 * 接口 [账户授权记录列表↗](http://yapi.cai-inc.com/project/3075/interface/api/590882) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `GET /zlb/api/pay/bank/receipt/account/page`
 * @更新时间 `2023-12-19 19:49:49`
 * @项目ID 3075
 */
export interface ZlbApiPayBankReceiptAccountPageGetRequest {
  /**
   * 付款账户是否需要脱敏
   */
  accountNoNeedDesensitize?: string;
  /**
   * 页面大小
   */
  pageSize?: string;
  /**
   * 页码
   */
  pageNo?: string;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
}

/**
 * 接口 [账户授权记录列表↗](http://yapi.cai-inc.com/project/3075/interface/api/590882) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `GET /zlb/api/pay/bank/receipt/account/page`
 * @更新时间 `2023-12-19 19:49:49`
 * @项目ID 3075
 */
export interface ZlbApiPayBankReceiptAccountPageGetResponse {
  success?: boolean;
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 平台账户唯一编号
       */
      accountAuthCode?: string;
      /**
       * 银行名称
       */
      bankName?: string;
      /**
       * 银行支行名称
       */
      bankBranchName?: string;
      /**
       * 银行账户
       */
      accountNo?: string;
      /**
       * 账户名称
       */
      accountName?: string;
      /**
       * 授权状态
       */
      authStatus?: 'UN_AUTH' | 'BE_AUTHORIZED';
      /**
       * 授权状态描述
       */
      authStatusDesc?: string;
      /**
       * 是否可授权
       * true:可授权
       * false：不可授权
       */
      canAuth?: boolean;
      /**
       * 是否可移除
       * true：可移除
       * false：不可移除
       */
      canRemove?: boolean;
    }[];
    /**
     * 第几页
     */
    pageNum?: number;
    /**
     * 每页记录数
     */
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 当前页的数量 <= pageSize，该属性来自ArrayList的size属性
     */
    size?: number;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [账户授权记录列表↗](http://yapi.cai-inc.com/project/3075/interface/api/590882) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `GET /zlb/api/pay/bank/receipt/account/page`
 * @更新时间 `2023-12-19 19:49:49`
 * @项目ID 3075
 */
type ZlbApiPayBankReceiptAccountPageGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bank/receipt/account/page',
    'data',
    string,
    'accountNoNeedDesensitize' | 'pageSize' | 'pageNo' | 'sortField' | 'sortBy',
    false
  >
>;

/**
 * 接口 [账户授权记录列表↗](http://yapi.cai-inc.com/project/3075/interface/api/590882) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `GET /zlb/api/pay/bank/receipt/account/page`
 * @更新时间 `2023-12-19 19:49:49`
 * @项目ID 3075
 */
const zlbApiPayBankReceiptAccountPageGetRequestConfig: ZlbApiPayBankReceiptAccountPageGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_3,
    devUrl: devUrl_0_6_0_3,
    prodUrl: prodUrl_0_6_0_3,
    path: '/zlb/api/pay/bank/receipt/account/page',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_3,
    paramNames: [],
    queryNames: ['accountNoNeedDesensitize', 'pageSize', 'pageNo', 'sortField', 'sortBy'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayBankReceiptAccountPageGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [账户授权记录列表↗](http://yapi.cai-inc.com/project/3075/interface/api/590882) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `GET /zlb/api/pay/bank/receipt/account/page`
 * @更新时间 `2023-12-19 19:49:49`
 * @项目ID 3075
 */
export const zlbApiPayBankReceiptAccountPageGet = /*#__PURE__*/ (
  requestData: ZlbApiPayBankReceiptAccountPageGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankReceiptAccountPageGetResponse>(
    prepare(zlbApiPayBankReceiptAccountPageGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankReceiptAccountPageGet.requestConfig = zlbApiPayBankReceiptAccountPageGetRequestConfig;

/**
 * 接口 [账户授权↗](http://yapi.cai-inc.com/project/3075/interface/api/590890) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `POST /zlb/api/pay/bank/receipt/account/auth`
 * @更新时间 `2023-12-19 19:49:50`
 * @项目ID 3075
 */
export interface ZlbApiPayBankReceiptAccountAuthPostRequest {
  /**
   * 平台账户唯一编号
   */
  accountAuthCode: string;
}

/**
 * 接口 [账户授权↗](http://yapi.cai-inc.com/project/3075/interface/api/590890) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `POST /zlb/api/pay/bank/receipt/account/auth`
 * @更新时间 `2023-12-19 19:49:50`
 * @项目ID 3075
 */
export interface ZlbApiPayBankReceiptAccountAuthPostResponse {
  success?: boolean;
  result?: {
    /**
     * 银行账户授权状态
     */
    status?: 'AUTH_SUCCESS' | 'AUTH_FAIL' | 'AUTH_ING';
    /**
     * 状态描述
     */
    desc?: string;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [账户授权↗](http://yapi.cai-inc.com/project/3075/interface/api/590890) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `POST /zlb/api/pay/bank/receipt/account/auth`
 * @更新时间 `2023-12-19 19:49:50`
 * @项目ID 3075
 */
type ZlbApiPayBankReceiptAccountAuthPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bank/receipt/account/auth',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [账户授权↗](http://yapi.cai-inc.com/project/3075/interface/api/590890) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `POST /zlb/api/pay/bank/receipt/account/auth`
 * @更新时间 `2023-12-19 19:49:50`
 * @项目ID 3075
 */
const zlbApiPayBankReceiptAccountAuthPostRequestConfig: ZlbApiPayBankReceiptAccountAuthPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_3,
    devUrl: devUrl_0_6_0_3,
    prodUrl: prodUrl_0_6_0_3,
    path: '/zlb/api/pay/bank/receipt/account/auth',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayBankReceiptAccountAuthPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [账户授权↗](http://yapi.cai-inc.com/project/3075/interface/api/590890) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `POST /zlb/api/pay/bank/receipt/account/auth`
 * @更新时间 `2023-12-19 19:49:50`
 * @项目ID 3075
 */
export const zlbApiPayBankReceiptAccountAuthPost = /*#__PURE__*/ (
  requestData: ZlbApiPayBankReceiptAccountAuthPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankReceiptAccountAuthPostResponse>(
    prepare(zlbApiPayBankReceiptAccountAuthPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankReceiptAccountAuthPost.requestConfig =
  zlbApiPayBankReceiptAccountAuthPostRequestConfig;

/**
 * 接口 [账户移除↗](http://yapi.cai-inc.com/project/3075/interface/api/590898) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `POST /zlb/api/pay/bank/receipt/account/remove`
 * @更新时间 `2023-12-19 19:49:50`
 * @项目ID 3075
 */
export interface ZlbApiPayBankReceiptAccountRemovePostRequest {
  /**
   * 平台账户唯一编号
   */
  accountAuthCode: string;
}

/**
 * 接口 [账户移除↗](http://yapi.cai-inc.com/project/3075/interface/api/590898) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `POST /zlb/api/pay/bank/receipt/account/remove`
 * @更新时间 `2023-12-19 19:49:50`
 * @项目ID 3075
 */
export interface ZlbApiPayBankReceiptAccountRemovePostResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [账户移除↗](http://yapi.cai-inc.com/project/3075/interface/api/590898) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `POST /zlb/api/pay/bank/receipt/account/remove`
 * @更新时间 `2023-12-19 19:49:50`
 * @项目ID 3075
 */
type ZlbApiPayBankReceiptAccountRemovePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bank/receipt/account/remove',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [账户移除↗](http://yapi.cai-inc.com/project/3075/interface/api/590898) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `POST /zlb/api/pay/bank/receipt/account/remove`
 * @更新时间 `2023-12-19 19:49:50`
 * @项目ID 3075
 */
const zlbApiPayBankReceiptAccountRemovePostRequestConfig: ZlbApiPayBankReceiptAccountRemovePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_3,
    devUrl: devUrl_0_6_0_3,
    prodUrl: prodUrl_0_6_0_3,
    path: '/zlb/api/pay/bank/receipt/account/remove',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayBankReceiptAccountRemovePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [账户移除↗](http://yapi.cai-inc.com/project/3075/interface/api/590898) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `POST /zlb/api/pay/bank/receipt/account/remove`
 * @更新时间 `2023-12-19 19:49:50`
 * @项目ID 3075
 */
export const zlbApiPayBankReceiptAccountRemovePost = /*#__PURE__*/ (
  requestData: ZlbApiPayBankReceiptAccountRemovePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankReceiptAccountRemovePostResponse>(
    prepare(zlbApiPayBankReceiptAccountRemovePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankReceiptAccountRemovePost.requestConfig =
  zlbApiPayBankReceiptAccountRemovePostRequestConfig;

/**
 * 接口 [银行回单归档↗](http://yapi.cai-inc.com/project/3075/interface/api/592562) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `POST /zlb/api/pay/bank/receipt/archive`
 * @更新时间 `2023-12-19 19:49:51`
 * @项目ID 3075
 */
export interface ZlbApiPayBankReceiptArchivePostRequest {
  /**
   * 关联凭证年月
   */
  relationTime: number;
  /**
   * 关联凭证号
   */
  documentNo: number;
  /**
   * 银行回单ID
   */
  voucherId: string;
}

/**
 * 接口 [银行回单归档↗](http://yapi.cai-inc.com/project/3075/interface/api/592562) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `POST /zlb/api/pay/bank/receipt/archive`
 * @更新时间 `2023-12-19 19:49:51`
 * @项目ID 3075
 */
export interface ZlbApiPayBankReceiptArchivePostResponse {
  success?: boolean;
  result?: {
    /**
     * 状态
     * true：归档成功
     * false：归档失败
     */
    status?: boolean;
    /**
     * 描述
     */
    desc?: string;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [银行回单归档↗](http://yapi.cai-inc.com/project/3075/interface/api/592562) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `POST /zlb/api/pay/bank/receipt/archive`
 * @更新时间 `2023-12-19 19:49:51`
 * @项目ID 3075
 */
type ZlbApiPayBankReceiptArchivePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bank/receipt/archive',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [银行回单归档↗](http://yapi.cai-inc.com/project/3075/interface/api/592562) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `POST /zlb/api/pay/bank/receipt/archive`
 * @更新时间 `2023-12-19 19:49:51`
 * @项目ID 3075
 */
const zlbApiPayBankReceiptArchivePostRequestConfig: ZlbApiPayBankReceiptArchivePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_3,
    devUrl: devUrl_0_6_0_3,
    prodUrl: prodUrl_0_6_0_3,
    path: '/zlb/api/pay/bank/receipt/archive',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayBankReceiptArchivePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [银行回单归档↗](http://yapi.cai-inc.com/project/3075/interface/api/592562) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `POST /zlb/api/pay/bank/receipt/archive`
 * @更新时间 `2023-12-19 19:49:51`
 * @项目ID 3075
 */
export const zlbApiPayBankReceiptArchivePost = /*#__PURE__*/ (
  requestData: ZlbApiPayBankReceiptArchivePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankReceiptArchivePostResponse>(
    prepare(zlbApiPayBankReceiptArchivePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankReceiptArchivePost.requestConfig = zlbApiPayBankReceiptArchivePostRequestConfig;

/**
 * 接口 [支持的银行列表↗](http://yapi.cai-inc.com/project/3075/interface/api/595394) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `GET /zlb/api/pay/bank/receipt/support-bank`
 * @更新时间 `2023-12-19 16:21:55`
 * @项目ID 3075
 */
export interface ZlbApiPayBankReceiptSupportBankGetRequest {}

/**
 * 接口 [支持的银行列表↗](http://yapi.cai-inc.com/project/3075/interface/api/595394) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `GET /zlb/api/pay/bank/receipt/support-bank`
 * @更新时间 `2023-12-19 16:21:55`
 * @项目ID 3075
 */
export interface ZlbApiPayBankReceiptSupportBankGetResponse {
  success?: boolean;
  result?: string[];
  code?: string;
  message?: string;
}

/**
 * 接口 [支持的银行列表↗](http://yapi.cai-inc.com/project/3075/interface/api/595394) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `GET /zlb/api/pay/bank/receipt/support-bank`
 * @更新时间 `2023-12-19 16:21:55`
 * @项目ID 3075
 */
type ZlbApiPayBankReceiptSupportBankGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bank/receipt/support-bank',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [支持的银行列表↗](http://yapi.cai-inc.com/project/3075/interface/api/595394) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `GET /zlb/api/pay/bank/receipt/support-bank`
 * @更新时间 `2023-12-19 16:21:55`
 * @项目ID 3075
 */
const zlbApiPayBankReceiptSupportBankGetRequestConfig: ZlbApiPayBankReceiptSupportBankGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_3,
    devUrl: devUrl_0_6_0_3,
    prodUrl: prodUrl_0_6_0_3,
    path: '/zlb/api/pay/bank/receipt/support-bank',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayBankReceiptSupportBankGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [支持的银行列表↗](http://yapi.cai-inc.com/project/3075/interface/api/595394) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `GET /zlb/api/pay/bank/receipt/support-bank`
 * @更新时间 `2023-12-19 16:21:55`
 * @项目ID 3075
 */
export const zlbApiPayBankReceiptSupportBankGet = /*#__PURE__*/ (
  requestData?: ZlbApiPayBankReceiptSupportBankGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankReceiptSupportBankGetResponse>(
    prepare(zlbApiPayBankReceiptSupportBankGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankReceiptSupportBankGet.requestConfig = zlbApiPayBankReceiptSupportBankGetRequestConfig;

/**
 * 接口 [保存单位授权账户↗](http://yapi.cai-inc.com/project/3075/interface/api/595402) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `POST /zlb/api/pay/bank/receipt/account/save`
 * @更新时间 `2023-12-19 19:49:49`
 * @项目ID 3075
 */
export interface ZlbApiPayBankReceiptAccountSavePostRequest {
  /**
   * 平台账户唯一编号
   */
  accountCodeList: string[];
}

/**
 * 接口 [保存单位授权账户↗](http://yapi.cai-inc.com/project/3075/interface/api/595402) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `POST /zlb/api/pay/bank/receipt/account/save`
 * @更新时间 `2023-12-19 19:49:49`
 * @项目ID 3075
 */
export interface ZlbApiPayBankReceiptAccountSavePostResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [保存单位授权账户↗](http://yapi.cai-inc.com/project/3075/interface/api/595402) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `POST /zlb/api/pay/bank/receipt/account/save`
 * @更新时间 `2023-12-19 19:49:49`
 * @项目ID 3075
 */
type ZlbApiPayBankReceiptAccountSavePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bank/receipt/account/save',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [保存单位授权账户↗](http://yapi.cai-inc.com/project/3075/interface/api/595402) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `POST /zlb/api/pay/bank/receipt/account/save`
 * @更新时间 `2023-12-19 19:49:49`
 * @项目ID 3075
 */
const zlbApiPayBankReceiptAccountSavePostRequestConfig: ZlbApiPayBankReceiptAccountSavePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_3,
    devUrl: devUrl_0_6_0_3,
    prodUrl: prodUrl_0_6_0_3,
    path: '/zlb/api/pay/bank/receipt/account/save',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayBankReceiptAccountSavePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [保存单位授权账户↗](http://yapi.cai-inc.com/project/3075/interface/api/595402) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `POST /zlb/api/pay/bank/receipt/account/save`
 * @更新时间 `2023-12-19 19:49:49`
 * @项目ID 3075
 */
export const zlbApiPayBankReceiptAccountSavePost = /*#__PURE__*/ (
  requestData: ZlbApiPayBankReceiptAccountSavePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankReceiptAccountSavePostResponse>(
    prepare(zlbApiPayBankReceiptAccountSavePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankReceiptAccountSavePost.requestConfig =
  zlbApiPayBankReceiptAccountSavePostRequestConfig;

/**
 * 接口 [支持的银行列表↗](http://yapi.cai-inc.com/project/3075/interface/api/595418) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `GET /zlb/api/pay/bank/receipt/support-bank-list`
 * @更新时间 `2023-12-19 19:49:49`
 * @项目ID 3075
 */
export interface ZlbApiPayBankReceiptSupportBankListGetRequest {}

/**
 * 接口 [支持的银行列表↗](http://yapi.cai-inc.com/project/3075/interface/api/595418) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `GET /zlb/api/pay/bank/receipt/support-bank-list`
 * @更新时间 `2023-12-19 19:49:49`
 * @项目ID 3075
 */
export interface ZlbApiPayBankReceiptSupportBankListGetResponse {
  success?: boolean;
  result?: string[];
  code?: string;
  message?: string;
}

/**
 * 接口 [支持的银行列表↗](http://yapi.cai-inc.com/project/3075/interface/api/595418) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `GET /zlb/api/pay/bank/receipt/support-bank-list`
 * @更新时间 `2023-12-19 19:49:49`
 * @项目ID 3075
 */
type ZlbApiPayBankReceiptSupportBankListGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bank/receipt/support-bank-list',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [支持的银行列表↗](http://yapi.cai-inc.com/project/3075/interface/api/595418) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `GET /zlb/api/pay/bank/receipt/support-bank-list`
 * @更新时间 `2023-12-19 19:49:49`
 * @项目ID 3075
 */
const zlbApiPayBankReceiptSupportBankListGetRequestConfig: ZlbApiPayBankReceiptSupportBankListGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_3,
    devUrl: devUrl_0_6_0_3,
    prodUrl: prodUrl_0_6_0_3,
    path: '/zlb/api/pay/bank/receipt/support-bank-list',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayBankReceiptSupportBankListGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [支持的银行列表↗](http://yapi.cai-inc.com/project/3075/interface/api/595418) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `GET /zlb/api/pay/bank/receipt/support-bank-list`
 * @更新时间 `2023-12-19 19:49:49`
 * @项目ID 3075
 */
export const zlbApiPayBankReceiptSupportBankListGet = /*#__PURE__*/ (
  requestData?: ZlbApiPayBankReceiptSupportBankListGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankReceiptSupportBankListGetResponse>(
    prepare(zlbApiPayBankReceiptSupportBankListGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankReceiptSupportBankListGet.requestConfig =
  zlbApiPayBankReceiptSupportBankListGetRequestConfig;

/**
 * 接口 [获取单位账户列表↗](http://yapi.cai-inc.com/project/3075/interface/api/595490) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `POST /zlb/api/pay/bank/receipt/org-account/list`
 * @更新时间 `2023-12-19 19:49:49`
 * @项目ID 3075
 */
export interface ZlbApiPayBankReceiptOrgAccountListPostRequest {
  /**
   * 银行卡号
   */
  bankCardNo?: string;
  /**
   * 账户类型
   */
  accountType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
  /**
   * 银行名字列表
   */
  bankNames?: string[];
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
}

/**
 * 接口 [获取单位账户列表↗](http://yapi.cai-inc.com/project/3075/interface/api/595490) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `POST /zlb/api/pay/bank/receipt/org-account/list`
 * @更新时间 `2023-12-19 19:49:49`
 * @项目ID 3075
 */
export interface ZlbApiPayBankReceiptOrgAccountListPostResponse {
  success?: boolean;
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 主键
       */
      id?: number;
      /**
       * 平台账户唯一编号
       */
      accountCode?: string;
      /**
       * 公务卡三方账户id，唯一主键，用来分析和排查是否重复拉取问题
       */
      thirdAccountCode?: string;
      /**
       * 用户id
       */
      userId?: number;
      /**
       * 用户机构id
       */
      userOrgId?: number;
      /**
       * 用户名称
       */
      userName?: string;
      /**
       * 财政区划代码
       */
      finaDivCode?: string;
      /**
       * 单位代码
       */
      companyCode?: string;
      /**
       * 单位名称
       */
      companyName?: string;
      /**
       * 银行区域代码
       */
      bankAreaCode?: string;
      /**
       * 银行代码
       */
      bankCode?: string;
      /**
       * 银行行号
       */
      bankNo?: string;
      /**
       * 银行名称
       */
      bankName?: string;
      /**
       * 开户城市
       */
      bankCity?: string;
      /**
       * 银行支行名称
       */
      bankBranchName?: string;
      /**
       * 银行账户
       */
      accountNo?: string;
      /**
       * 不拖敏
       */
      accountNoWithoutDes?: string;
      /**
       * 账户名称
       */
      accountName?: string;
      /**
       * 账户状态：0-未启用；1-启用
       */
      accountStatus?: number;
      /**
       * 账户类型：1-公务卡；2-普通银行卡；3-单位工资卡；4-对公供应商银行卡；5-对私供销商银行卡 6-单位账户
       */
      accountType?: number;
      /**
       * 账户类型名称
       */
      accountTypeName?: string;
      /**
       * 账户类型：1-个人；2-单位
       */
      accountLevel?: number;
      /**
       * 账户类型名称
       */
      accountLevelName?: string;
      /**
       * 是否默认账户：0-否；1-是
       */
      isDefault?: number;
      /**
       * 支付状态 0：未支付 1:已支付
       */
      isPay?: number;
      /**
       * 备案状态，0：未备案 1：备案成功 2：备案失败，参照：{link FilingStatusEnum}
       */
      filingStatus?: number;
      /**
       * 备案过期时间
       */
      expireDate?: string;
      /**
       * 备注
       */
      remark?: string;
      /**
       * 用户ID
       */
      operatorId?: number;
      /**
       * 开户支行别名
       */
      bankBranchAliasName?: string;
      /**
       * 收款人身份证号
       */
      receiveIdNumber?: string;
    }[];
    /**
     * 第几页
     */
    pageNum?: number;
    /**
     * 每页记录数
     */
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 当前页的数量 <= pageSize，该属性来自ArrayList的size属性
     */
    size?: number;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [获取单位账户列表↗](http://yapi.cai-inc.com/project/3075/interface/api/595490) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `POST /zlb/api/pay/bank/receipt/org-account/list`
 * @更新时间 `2023-12-19 19:49:49`
 * @项目ID 3075
 */
type ZlbApiPayBankReceiptOrgAccountListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/bank/receipt/org-account/list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [获取单位账户列表↗](http://yapi.cai-inc.com/project/3075/interface/api/595490) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `POST /zlb/api/pay/bank/receipt/org-account/list`
 * @更新时间 `2023-12-19 19:49:49`
 * @项目ID 3075
 */
const zlbApiPayBankReceiptOrgAccountListPostRequestConfig: ZlbApiPayBankReceiptOrgAccountListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_3,
    devUrl: devUrl_0_6_0_3,
    prodUrl: prodUrl_0_6_0_3,
    path: '/zlb/api/pay/bank/receipt/org-account/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayBankReceiptOrgAccountListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取单位账户列表↗](http://yapi.cai-inc.com/project/3075/interface/api/595490) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [银行回单相关API↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52001)
 * @请求头 `POST /zlb/api/pay/bank/receipt/org-account/list`
 * @更新时间 `2023-12-19 19:49:49`
 * @项目ID 3075
 */
export const zlbApiPayBankReceiptOrgAccountListPost = /*#__PURE__*/ (
  requestData: ZlbApiPayBankReceiptOrgAccountListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayBankReceiptOrgAccountListPostResponse>(
    prepare(zlbApiPayBankReceiptOrgAccountListPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayBankReceiptOrgAccountListPost.requestConfig =
  zlbApiPayBankReceiptOrgAccountListPostRequestConfig;

const mockUrl_0_6_0_4 = 'http://yapi.cai-inc.com/mock/3075' as any;
const devUrl_0_6_0_4 = '' as any;
const prodUrl_0_6_0_4 = '' as any;
const dataKey_0_6_0_4 = 'data' as any;

/**
 * 接口 [导入任务提交↗](http://yapi.cai-inc.com/project/3075/interface/api/507106) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [文件导入控制层↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52671)
 * @请求头 `POST /zlb/api/pay/import/submit`
 * @更新时间 `2024-06-13 15:44:26`
 * @项目ID 3075
 */
export interface ZlbApiPayImportSubmitPostRequest {
  /**
   * 待导入的文件ossId
   */
  fileId: string;
  /**
   * 导入任务类型
   */
  importType: string;
}

/**
 * 接口 [导入任务提交↗](http://yapi.cai-inc.com/project/3075/interface/api/507106) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [文件导入控制层↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52671)
 * @请求头 `POST /zlb/api/pay/import/submit`
 * @更新时间 `2024-06-13 15:44:26`
 * @项目ID 3075
 */
export interface ZlbApiPayImportSubmitPostResponse {
  success?: boolean;
  result?: string;
  code?: string;
  message?: string;
}

/**
 * 接口 [导入任务提交↗](http://yapi.cai-inc.com/project/3075/interface/api/507106) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [文件导入控制层↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52671)
 * @请求头 `POST /zlb/api/pay/import/submit`
 * @更新时间 `2024-06-13 15:44:26`
 * @项目ID 3075
 */
type ZlbApiPayImportSubmitPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/import/submit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [导入任务提交↗](http://yapi.cai-inc.com/project/3075/interface/api/507106) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [文件导入控制层↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52671)
 * @请求头 `POST /zlb/api/pay/import/submit`
 * @更新时间 `2024-06-13 15:44:26`
 * @项目ID 3075
 */
const zlbApiPayImportSubmitPostRequestConfig: ZlbApiPayImportSubmitPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_4,
    devUrl: devUrl_0_6_0_4,
    prodUrl: prodUrl_0_6_0_4,
    path: '/zlb/api/pay/import/submit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayImportSubmitPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [导入任务提交↗](http://yapi.cai-inc.com/project/3075/interface/api/507106) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [文件导入控制层↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52671)
 * @请求头 `POST /zlb/api/pay/import/submit`
 * @更新时间 `2024-06-13 15:44:26`
 * @项目ID 3075
 */
export const zlbApiPayImportSubmitPost = /*#__PURE__*/ (
  requestData: ZlbApiPayImportSubmitPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayImportSubmitPostResponse>(
    prepare(zlbApiPayImportSubmitPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayImportSubmitPost.requestConfig = zlbApiPayImportSubmitPostRequestConfig;

/**
 * 接口 [保存导入的数据↗](http://yapi.cai-inc.com/project/3075/interface/api/507114) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [文件导入控制层↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52671)
 * @请求头 `POST /zlb/api/pay/import/save`
 * @更新时间 `2024-06-13 15:44:26`
 * @项目ID 3075
 */
export interface ZlbApiPayImportSavePostRequest {
  /**
   * 任务序列号
   */
  serialCode?: string;
}

/**
 * 接口 [保存导入的数据↗](http://yapi.cai-inc.com/project/3075/interface/api/507114) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [文件导入控制层↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52671)
 * @请求头 `POST /zlb/api/pay/import/save`
 * @更新时间 `2024-06-13 15:44:26`
 * @项目ID 3075
 */
export interface ZlbApiPayImportSavePostResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [保存导入的数据↗](http://yapi.cai-inc.com/project/3075/interface/api/507114) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [文件导入控制层↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52671)
 * @请求头 `POST /zlb/api/pay/import/save`
 * @更新时间 `2024-06-13 15:44:26`
 * @项目ID 3075
 */
type ZlbApiPayImportSavePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/import/save',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [保存导入的数据↗](http://yapi.cai-inc.com/project/3075/interface/api/507114) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [文件导入控制层↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52671)
 * @请求头 `POST /zlb/api/pay/import/save`
 * @更新时间 `2024-06-13 15:44:26`
 * @项目ID 3075
 */
const zlbApiPayImportSavePostRequestConfig: ZlbApiPayImportSavePostRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_6_0_4,
  devUrl: devUrl_0_6_0_4,
  prodUrl: prodUrl_0_6_0_4,
  path: '/zlb/api/pay/import/save',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_6_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'zlbApiPayImportSavePost',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 [保存导入的数据↗](http://yapi.cai-inc.com/project/3075/interface/api/507114) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [文件导入控制层↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52671)
 * @请求头 `POST /zlb/api/pay/import/save`
 * @更新时间 `2024-06-13 15:44:26`
 * @项目ID 3075
 */
export const zlbApiPayImportSavePost = /*#__PURE__*/ (
  requestData: ZlbApiPayImportSavePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayImportSavePostResponse>(
    prepare(zlbApiPayImportSavePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayImportSavePost.requestConfig = zlbApiPayImportSavePostRequestConfig;

/**
 * 接口 [获取导入结果↗](http://yapi.cai-inc.com/project/3075/interface/api/507122) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [文件导入控制层↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52671)
 * @请求头 `POST /zlb/api/pay/import/result`
 * @更新时间 `2024-06-13 15:44:26`
 * @项目ID 3075
 */
export interface ZlbApiPayImportResultPostRequest {
  /**
   * 任务编号
   */
  serialCode: string;
}

/**
 * 接口 [获取导入结果↗](http://yapi.cai-inc.com/project/3075/interface/api/507122) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [文件导入控制层↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52671)
 * @请求头 `POST /zlb/api/pay/import/result`
 * @更新时间 `2024-06-13 15:44:26`
 * @项目ID 3075
 */
export interface ZlbApiPayImportResultPostResponse {
  success?: boolean;
  result?: {
    /**
     * 导入总条数
     */
    totalNum?: number;
    /**
     * 成功条数
     */
    successNum?: number;
    /**
     * 失败条数
     */
    failNum?: number;
    /**
     * 重复条数（特殊逻辑）
     */
    duplicateNum?: number;
    /**
     * 完整fileId
     */
    failFileId?: string;
    /**
     * 异常信息
     */
    message?: string;
    /**
     * 任务序列号
     */
    serialCode?: string;
    /**
     * 操作员id
     */
    operatorId?: number;
    /**
     * 机构id
     */
    orgId?: number;
    /**
     * 操作员姓名
     */
    operatorName?: string;
    /**
     * 任务状态 0-解析中 1-成功 2-失败 3-部分失败
     */
    status?: number;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [获取导入结果↗](http://yapi.cai-inc.com/project/3075/interface/api/507122) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [文件导入控制层↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52671)
 * @请求头 `POST /zlb/api/pay/import/result`
 * @更新时间 `2024-06-13 15:44:26`
 * @项目ID 3075
 */
type ZlbApiPayImportResultPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/import/result',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [获取导入结果↗](http://yapi.cai-inc.com/project/3075/interface/api/507122) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [文件导入控制层↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52671)
 * @请求头 `POST /zlb/api/pay/import/result`
 * @更新时间 `2024-06-13 15:44:26`
 * @项目ID 3075
 */
const zlbApiPayImportResultPostRequestConfig: ZlbApiPayImportResultPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_4,
    devUrl: devUrl_0_6_0_4,
    prodUrl: prodUrl_0_6_0_4,
    path: '/zlb/api/pay/import/result',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayImportResultPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取导入结果↗](http://yapi.cai-inc.com/project/3075/interface/api/507122) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [文件导入控制层↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52671)
 * @请求头 `POST /zlb/api/pay/import/result`
 * @更新时间 `2024-06-13 15:44:26`
 * @项目ID 3075
 */
export const zlbApiPayImportResultPost = /*#__PURE__*/ (
  requestData: ZlbApiPayImportResultPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayImportResultPostResponse>(
    prepare(zlbApiPayImportResultPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayImportResultPost.requestConfig = zlbApiPayImportResultPostRequestConfig;

/**
 * 接口 [获取模板地址↗](http://yapi.cai-inc.com/project/3075/interface/api/507130) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [文件导入控制层↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52671)
 * @请求头 `GET /zlb/api/pay/import/get-template`
 * @更新时间 `2024-06-13 15:44:26`
 * @项目ID 3075
 */
export interface ZlbApiPayImportGetTemplateGetRequest {
  /**
   * 模板类型
   */
  type?: string;
}

/**
 * 接口 [获取模板地址↗](http://yapi.cai-inc.com/project/3075/interface/api/507130) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [文件导入控制层↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52671)
 * @请求头 `GET /zlb/api/pay/import/get-template`
 * @更新时间 `2024-06-13 15:44:26`
 * @项目ID 3075
 */
export interface ZlbApiPayImportGetTemplateGetResponse {
  success?: boolean;
  result?: string;
  code?: string;
  message?: string;
}

/**
 * 接口 [获取模板地址↗](http://yapi.cai-inc.com/project/3075/interface/api/507130) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [文件导入控制层↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52671)
 * @请求头 `GET /zlb/api/pay/import/get-template`
 * @更新时间 `2024-06-13 15:44:26`
 * @项目ID 3075
 */
type ZlbApiPayImportGetTemplateGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3075',
    '',
    '',
    '/zlb/api/pay/import/get-template',
    'data',
    string,
    'type',
    false
  >
>;

/**
 * 接口 [获取模板地址↗](http://yapi.cai-inc.com/project/3075/interface/api/507130) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [文件导入控制层↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52671)
 * @请求头 `GET /zlb/api/pay/import/get-template`
 * @更新时间 `2024-06-13 15:44:26`
 * @项目ID 3075
 */
const zlbApiPayImportGetTemplateGetRequestConfig: ZlbApiPayImportGetTemplateGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_4,
    devUrl: devUrl_0_6_0_4,
    prodUrl: prodUrl_0_6_0_4,
    path: '/zlb/api/pay/import/get-template',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_4,
    paramNames: [],
    queryNames: ['type'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiPayImportGetTemplateGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取模板地址↗](http://yapi.cai-inc.com/project/3075/interface/api/507130) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [文件导入控制层↗](http://yapi.cai-inc.com/project/3075/interface/api/cat_52671)
 * @请求头 `GET /zlb/api/pay/import/get-template`
 * @更新时间 `2024-06-13 15:44:26`
 * @项目ID 3075
 */
export const zlbApiPayImportGetTemplateGet = /*#__PURE__*/ (
  requestData: ZlbApiPayImportGetTemplateGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiPayImportGetTemplateGetResponse>(
    prepare(zlbApiPayImportGetTemplateGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiPayImportGetTemplateGet.requestConfig = zlbApiPayImportGetTemplateGetRequestConfig;

/* prettier-ignore-end */
